// Svenska — källspråket. Strukturen här styr nycklarna (MessageKey) och
// vad en.ts måste innehålla. Se index.ts för hur t()/tn()/vl() används.
const sv = {
  appError: {
    title: 'Något gick fel',
    body: 'Sidan kunde inte visas. Felet har rapporterats automatiskt. Ladda om sidan och försök igen.',
    reload: 'Ladda om sidan',
  },
  legal: {
    terms: 'Användarvillkor',
    privacy: 'Integritetspolicy',
    acceptLabel: 'Jag godkänner {terms} och har tagit del av {privacy}.',
    mustAccept: 'Du behöver godkänna användarvillkoren',
    comingSoon: 'Texten publiceras inom kort. Har du frågor under tiden? Skriv till info@qvestium.com.',
    back: '← Till Qvestium',
    updatedTitle: 'Vi har uppdaterat våra villkor',
    updatedBody: 'Läs igenom {terms} och {privacy}. För att fortsätta använda Qvestium behöver du godkänna dem.',
    accept: 'Jag godkänner',
    loading: 'Laddar…',
  },
  sellerType: {
    title: 'Säljare',
    intro: 'Säljer eller hyr du ut som privatperson eller företag? Det visas för köpare, eftersom konsumentskyddet (konsumentköplagen och ångerrätt) bara gäller när säljaren är ett företag. Du behöver ange det innan du lägger ut plagg.',
    private: 'Privatperson',
    business: 'Företag',
    businessName: 'Företagets namn',
    orgNumber: 'Organisationsnummer',
    vatNumber: 'Momsregistreringsnummer (valfritt)',
    address: 'Företagets adress (visas för köpare)',
    save: 'Spara',
    saved: 'Sparat',
    notSet: 'Inte angivet än',
    buyerPrivate: 'Säljs av en privatperson. Konsumentköplagen och ångerrätt gäller inte vid köp mellan privatpersoner, men Qvestiums köparskydd gäller.',
    buyerBusiness: 'Säljs av företaget {name}, org.nr {org}, {address}. Som konsument har du ångerrätt och skydd enligt konsumentköplagen mot säljaren.',
  },
  myData: {
    title: 'Dina uppgifter',
    intro: 'Ladda ner allt vi har sparat om dig, eller radera ditt konto.',
    download: 'Ladda ner mina uppgifter',
    delete: 'Radera mitt konto',
    deleteTitle: 'Radera kontot',
    deleteBody: 'Din profil, adress, dina annonser och bilder, gillningar, sparade kort och kopplingar raderas. Meddelanden och omdömen som finns kvar hos andra visas som från "Raderad användare". Omdömen som andra gett dig sparas utan ditt namn, och loggar du in igen med samma e-post kopplas de tillbaka. Har du loggat in med Apple återkallas Qvestiums koppling till ditt Apple-ID. Affärer och betalningar sparas i sju år enligt bokföringslagen. Inloggningen (Qid), som delas med övriga Q-tjänster, finns kvar — kontakta info@qvestium.com om du vill att den också raderas.',
    typeToConfirm: 'Skriv RADERA för att bekräfta',
    confirmDelete: 'Radera kontot för gott',
    cannotDelete: 'Kontot kan inte raderas ännu: {reasons}. Kontakta info@qvestium.com om du har frågor.',
    deleted: 'Ditt konto är raderat.',
  },
  taxInfo: {
    title: 'Skatteuppgifter (DAC7)',
    intro: 'Säljer du minst 30 plagg eller för mer än 2 000 euro (cirka 22 000 kr) per år ska Qvestium enligt lag rapportera dina försäljningar till Skatteverket. Då behöver vi dina uppgifter. Personnumret lagras krypterat och visas aldrig för andra. Uthyrning omfattas inte.',
    requiredNotice: 'Du närmar dig gränsen — lämna dina uppgifter senast {date}.',
    heldNotice: 'Dina utbetalningar (försäljning och uthyrning) är pausade tills uppgifterna har kommit in.',
    submitted: 'Inlämnat {date}: {name}, {tin}.',
    update: 'Ändra uppgifterna',
    individual: 'Privatperson',
    entity: 'Företag',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    personnummer: 'Personnummer (ÅÅÅÅMMDD-NNNN)',
    legalName: 'Företagets namn',
    orgNumber: 'Organisationsnummer',
    vatNumber: 'Momsregistreringsnummer (valfritt)',
    address: 'Adress',
    postalCode: 'Postnummer',
    city: 'Ort',
    save: 'Spara uppgifterna',
    saved: 'Sparat — tack!',
    show: 'Lämna uppgifter',
    adminTitle: 'DAC7-underlag',
    adminIntro: 'Säljare som ska rapporteras till Skatteverket (minst 30 försäljningar eller över 2 000 euro), med antal och belopp per kvartal. Rapporten lämnas senast 31 januari året efter.',
    adminDownload: 'Ladda ner {year} (CSV)',
  },
  meta: {
    title: 'Qvestium — Modemarknad',
  },
  language: {
    label: 'Språk',
  },
  common: {
    member: 'Qvestium-medlem',
    cancel: 'Avbryt',
    save: 'Spara',
    saving: 'Sparar...',
    saveChanges: 'Spara ändringar',
    close: 'Stäng',
    loading: 'Laddar...',
    back: 'Tillbaka',
    delete: 'Ta bort',
    edit: 'Redigera',
    confirm: 'Bekräfta',
    send: 'Skicka',
    sending: 'Skickar...',
    logIn: 'Logga in',
    createAccount: 'Skapa konto',
    upload: 'Ladda upp',
    or: 'eller',
    somethingWentWrong: 'Något gick fel',
    authRequired: 'Autentisering krävs',
    kr: '{amount} kr',
    krPerMonth: '{amount} kr/mån',
    months: '{count} mån',
    buy: 'Köp',
    rent: 'Hyra',
    swap: 'Byte',
    seller: 'Säljare',
    buyer: 'Köpare',
    price: 'Pris',
    size: 'Storlek',
    category: 'Kategori',
    description: 'Beskrivning',
    pay: 'Betala',
    reject: 'Avböj',
    permanent: 'Permanent',
  },
  api: {
    appleLoginFailed: 'Apple-inloggning misslyckades',
    appleNoAccount: 'Det finns inget Qvestium-konto för det här Apple-kontot än. Skapa ett konto med e-post och inbjudningskod först (eller logga in med Google), så kan du sedan logga in med Apple. Valde du "Dölj min e-post" hos Apple hittar vi inte ditt konto – välj "Dela min e-post" i stället.',
    noAccount: 'Det finns inget Qvestium-konto för det här kontot än.',
    enterInviteCode: 'Ange din inbjudningskod',
    googleLoginFailed: 'Google-inloggning misslyckades',
    googleNoAccountInApp: 'Det finns inget Qvestium-konto för det här Google-kontot än. Skapa ett konto med e-post och inbjudningskod här i appen, eller med Google på qvestium.com.',
    popupBlocked: 'Inloggningsfönstret blockerades av webbläsaren',
    popupClosed: 'Inloggningsfönstret stängdes innan inloggningen var klar',
    stateMismatch: 'Inloggningen kunde inte verifieras — försök igen',
    tokenExchangeFailed: 'Inloggningen misslyckades',
    fetchUserFailed: 'Kunde inte hämta användaruppgifter',
    loginFailed: 'Inloggning misslyckades',
    registrationFailed: 'Registrering misslyckades',
    wrongCode: 'Fel kod',
    resendCodeFailed: 'Kunde inte skicka en ny kod',
    newCodeSent: 'En ny kod är skickad',
    insuranceQuoteFailed: 'Kunde inte hämta försäkringspris',
    requestNotFound: 'Förfrågan hittades inte',
    paymentStartFailed: 'Kunde inte starta betalningen',
    verificationStartFailed: 'Kunde inte starta verifieringen',
    shipmentCheckFailed: 'Kunde inte kontrollera sändningen',
    paymentSessionFailed: 'Kunde inte skapa betalningssession',
    uploadFailed: 'Upload misslyckades',
    aiImageFailed: 'AI-bildgenerering misslyckades',
    tryOnFailed: 'Kunde inte testa plagget',
    qUnavailable: 'Q kunde inte svara just nu',
    vintedImportFailed: 'Kunde inte starta Vinted-importen',
    importStatusFailed: 'Kunde inte hämta importstatus',
    analyzeFailed: 'Kunde inte analysera plagget',
  },
  featured: {
    badge: 'Featured',
    title: 'Featured',
    explainer: 'Featured-annonser visas överst i marknaden.',
    byQvestium: 'Utvald av Qvestium — visas överst i marknaden.',
    until: 'Visas överst i marknaden till och med {date}.',
    notListed: 'Lista plagget för försäljning, uthyrning eller byte för att kunna göra det featured.',
    featureWeek: 'Gör featured i en vecka',
    extendWeek: 'Förläng en vecka',
    creditsLeft: { one: 'Du har {count} featured-vecka kvar', other: 'Du har {count} featured-veckor kvar' },
    buyPack: 'Köp featured — {items} plagg för {price} kr',
    packInfo: 'Ett paket ger {items} plagg i en vecka var ({perWeek} kr per plagg och vecka). Det här plagget blir featured direkt, och de {rest} andra veckorna kan du lägga på andra plagg när du vill.',
    adminFeature: 'Gör featured (admin)',
    adminRemove: 'Ta bort featured (admin)',
    confirmRemovePaid: 'Ägaren har betalat för den här veckan. Ta bort featured ändå?',
  },
  // ── Komponenter (genererat) ──
  favoriteHeartButton: {
    removeSaved: 'Ta bort från sparade',
    save: 'Spara',
  },
  aiImageBadge: {
    label: 'AI-bild',
  },
  wardrobeLikeButton: {
    unlike: 'Ta bort gillamarkering',
    like: 'Gilla',
  },
  ownerLikesBadge: {
    likes: { one: '{count} gillar', other: '{count} gillar' },
  },
  likersModal: {
    loadError: 'Kunde inte hämta gillamarkeringar',
    title: 'Gillat av',
    empty: 'Ingen har gillat plagget än',
  },
  loginModal: {
    forgotPassword: 'Glömt lösenordet?',
    forgotTitle: 'Nytt lösenord',
    forgotIntro: 'Ange e-postadressen du loggar in med, så mejlar vi en kod för att välja ett nytt lösenord.',
    sendResetCode: 'Skicka kod',
    newPasswordLabel: 'Nytt lösenord (minst 8 tecken)',
    saveNewPassword: 'Spara och logga in',
    passwordMismatch: 'Lösenorden matchar inte',
    inviteCodeRequired: 'Ange din inbjudningskod',
    wrongCode: 'Fel kod',
    resendFailed: 'Kunde inte skicka en ny kod',
    loginCancelled: 'Inloggningen avbröts',
    popupBlocked: 'Webbläsaren blockerade Google-fönstret. Klicka på knappen igen — hjälper inte det, tillåt popup-fönster för qvestium.com.',
    googleLoginFailed: 'Kunde inte logga in med Google',
    wrongInviteCode: 'Fel inbjudningskod',
    createAccountFailed: 'Kunde inte skapa kontot',
    confirmEmailTitle: 'Bekräfta din e-post',
    codeSentDefault: 'Vi har skickat en sexsiffrig kod till din e-post.',
    codeSentTo: 'Koden skickades till {email}.',
    codeLabel: 'Kod från mejlet',
    resendCode: 'Skicka ny kod',
    googleInviteIntro: 'Du har inget konto på Qvestium än. Ange din inbjudningskod för att skapa ett med ditt Google-konto.',
    inviteCodeLabel: 'Inbjudningskod',
    continueWithGoogle: 'Fortsätt med Google',
    continueWithApple: 'Fortsätt med Apple',
    appleLoginFailed: 'Kunde inte logga in med Apple',
    orWithEmail: 'eller med e-post',
    emailLabel: 'E-post',
    emailPlaceholder: 'din@email.se',
    passwordLabel: 'Lösenord',
    confirmPasswordLabel: 'Bekräfta lösenord',
  },
  collectionCard: {
    featured: 'Utvald',
    spotsLeft: '{count} kvar',
    orMonthly: 'eller {amount} kr/mån',
    seeMore: 'Se mer',
  },
  marketplaceWardrobeCard: {
    sizeShort: 'Stl {size}',
    buyPrice: '{amount} kr köp',
    orBuyPrice: 'eller {amount} kr köp',
    openForSwap: 'Öppen för byte',
    rent: 'Hyr',
    buyFor: 'Köp {amount} kr',
    inclBuyerProtection: '{amount} kr inkl. köparskydd',
  },
  shopCard: {
    soldOut: 'Slutsåld',
    draft: 'Utkast',
    sizeShort: 'Stl {size}',
    orBuyPrice: 'eller {amount} {unit} köp',
    rent: 'Hyr',
  },
  conditionLabels: {
    worn: 'Slitet',
    used: 'Använt',
    good: 'Bra',
    veryGood: 'Mycket bra',
    unused: 'Oanvänd',
  },
  weightTierOptions: {
    light: 'Lätt (under 1 kg) — {amount} kr frakt',
    medium: 'Mellan (1–2 kg) — {amount} kr frakt',
    heavy: 'Tungt (2–3 kg) — {amount} kr frakt',
  },
  sortOptions: {
    newest: 'Nyast',
    priceAsc: 'Pris: Lägst till högst',
    priceDesc: 'Pris: Högst till lägst',
  },
  marketplaceFilterBar: {
    sortBy: 'Sortera efter',
    sortByValue: 'Sortera efter: {option}',
    condition: 'Skick',
    sizes: 'Storlekar',
    noSizes: 'Inga storlekar att filtrera på',
    minPrice: 'Min (kr)',
    maxPrice: 'Max (kr)',
    clearFilters: 'Rensa filter',
  },
  tryOnButton: {
    generateFailed: 'Kunde inte generera bilden',
    generating: 'Skapar bild av dig i plagget... (kan ta ~30s)',
    tryOn: 'Testa plagg på mig',
    noPhoto: 'Ladda upp en helkroppsbild i {link} för att testa plagg på dig.',
    yourProfile: 'din profil',
    pickPhoto: 'Välj bild:',
    resultTitle: 'Så skulle det kunna se ut på dig',
    aiDisclaimer: 'AI-genererad bild — en visuell approximation, inte en exakt passform.',
  },
  outfits: {
    title: 'Outfits med Q',
    intro: 'Beskriv en stil, en referens eller ett tillfälle – eller lägg till en bild. Q kombinerar plagg ur din garderob med plagg att köpa eller hyra.',
    placeholder: 'T.ex. "old money", "Sofia Coppola på 90-talet" eller "festlig men avslappnad, bröllop i augusti"',
    addImage: 'Lägg till bild',
    removeImage: 'Ta bort bilden',
    submit: 'Föreslå outfits',
    working: 'Q sätter ihop outfits…',
    failed: 'Kunde inte ta fram outfits just nu.',
    imageUploadFailed: 'Bilden kunde inte laddas upp.',
    interpreted: 'Så tolkade jag det',
    none: 'Hittade inga kombinationer som håller ihop. Prova en annan beskrivning eller lägg till fler plagg i garderoben.',
    own: 'Eget',
    buy: 'Köp',
    rent: 'Hyr',
    priceBuy: '{amount} kr',
    priceRent: '{amount} kr/mån',
    totalBuy: 'Köp {amount} kr',
    totalRent: 'Hyra {amount} kr/mån',
    totalOwnOnly: 'Allt finns i din garderob',
    tryOn: 'Prova på mig',
    tryingOn: 'Skapar bild av dig… (kan ta ~30 s)',
    tryOnFailed: 'Kunde inte skapa bilden.',
    noBodyPhoto: 'Ladda upp en helkroppsbild i {link} för att se outfiten på dig.',
    yourProfile: 'din profil',
    showCollage: 'Visa plaggen',
    showOnMe: 'Visa på mig',
    aiDisclaimer: 'AI-genererad bild som bara du ser. En ungefärlig bild, inte exakt passform.',
  },
  productDetailPage: {
    priceOnce: '{amount} kr engång',
    size: 'Storlek {size}',
    choosePayment: 'Välj betalningsform',
    toPay: 'Att betala',
    bindingInfo: { one: 'Bindningstid {count} månad · Första månaden betalas vid start', other: 'Bindningstid {count} månader · Första månaden betalas vid start' },
    buyFor: 'Köp för {amount} kr',
    rentNow: 'Hyr nu · {price}',
  },
  collectionDetailModal: {
    logInToBook: 'Logga in för att boka kollektionen.',
    featured: 'UTVALD',
    designBy: 'Design av {designer}',
    highlights: 'Höjdpunkter',
    includes: 'Ingår',
    availability: 'Tillgänglighet',
    spotsLeft: '{available} av {total} kvar',
    orMonthly: 'eller {amount} kr/mån i 12 mån',
    yourDetails: 'Dina uppgifter',
    nameLabel: 'Namn *',
    namePlaceholder: 'Ditt namn',
    emailLabel: 'E-post *',
    emailPlaceholder: 'din@email.se',
    phoneLabel: 'Telefon',
    phonePlaceholder: '070-xxx xx xx',
    messageLabel: 'Meddelande',
    messagePlaceholder: 'Önskemål, frågor...',
    confirmTitle: 'Bekräfta beställning',
    summaryCollection: 'Kollektion: {value}',
    summaryName: 'Namn: {value}',
    summaryEmail: 'E-post: {value}',
    summarySize: 'Storlek: {value}',
    summaryPrice: 'Köppris: {value}',
    summaryMonthly: 'Månadspris: {value} (12 mån)',
    orderSent: 'Beställning skickad!',
    weWillReply: 'Vi återkommer till {email} med bekräftelse.',
    rentNow: 'Hyr nu',
    orderNow: 'Beställ nu',
    continue: 'Gå vidare',
  },
  bindingOptions: {
    flexible: 'Flexibel',
    popular: 'Populär',
    ownIt: 'Äg det',
  },
  crm: {
    intro: 'Profiler på andra secondhandsajter som vi vill få att börja sälja på Qvestium. Dra korten mellan stegen. Varje profil har en personlig inbjudningskod — registrerar de sig med den flyttas kortet automatiskt.',
    funnel: '{total} profiler · {contacted} kontaktade · {converted} registrerade · {active} har annonserat',
    loadFailed: 'Kunde inte hämta CRM:et',
    add: 'Lägg till profil',
    import: 'Importera lista',
    search: 'Sök namn, ort, stil …',
    allPlatforms: 'Alla sajter',
    allOwners: 'Alla ansvariga',
    allPriorities: 'Alla prioriteter',
    unnamed: 'Namnlös profil',
    notesCount: '{count} ant.',
    profileUrl: 'Profiladress',
    or: 'eller',
    platform: 'Sajt',
    handle: 'Användarnamn',
    displayName: 'Namn',
    owner: 'Ansvarig',
    priority: 'Prioritet',
    stage: 'Steg',
    contactEmail: 'E-post',
    contactPhone: 'Telefon',
    location: 'Ort',
    categories: 'Stil / kategorier',
    audience: 'Följare / annonser',
    nextStep: 'Nästa steg',
    nextStepDate: 'Datum',
    description: 'Anteckningar om profilen',
    save: 'Spara',
    importHint: 'Klistra in profiladresser, en per rad. Sajten och användarnamnet känns igen automatiskt, och profiler som redan finns hoppas över.',
    preview: 'Förhandsgranska',
    importCount: 'Importera {count}',
    willImport: 'Läggs till',
    openProfile: 'Öppna profilen',
    registeredAs: 'registrerad som {email}',
    inviteTitle: 'Personlig inbjudan · kod {code}',
    messageTemplate: 'Hej {name}! Vi har sett din garderob på {platform} och tror att den skulle passa perfekt på Qvestium — en ny svensk marknadsplats där du kan sälja, hyra ut och byta kläder. Du betalar ingen provision när du säljer.\n\nVi vill gärna bjuda in dig. Registrera dig med din personliga kod {code} här:\n{link}\n\nHälsningar\n{owner}, Qvestium',
    copyMessage: 'Kopiera meddelandet',
    copied: 'Kopierat!',
    noteKinds: { dm: 'DM', email: 'Mejl', call: 'Samtal', note: 'Anteckning' },
    notePlaceholder: 'Vad hände? (ett DM eller mejl flyttar en ny profil till Kontaktad)',
    addNote: 'Lägg till',
    gdprHint: 'Profiler som inte är intresserade bör raderas — vi sparar uppgifter om personer som inte är användare.',
    delete: 'Radera profilen',
    confirmDelete: 'Radera profilen och alla anteckningar?',
    stages: { identified: 'Identifierad', contacted: 'Kontaktad', replied: 'Svarat', registered: 'Registrerad', active: 'Aktiv', lost: 'Ej intresserad' },
    platforms: { vinted: 'Vinted', tradera: 'Tradera', sellpy: 'Sellpy', plick: 'Plick', blocket: 'Blocket', instagram: 'Instagram', facebook: 'Facebook', tiktok: 'TikTok', other: 'Annan' },
  },
  shipping: {
    shipping: 'Frakt',
    loading: 'Hämtar fraktpriser …',
    loadFailed: 'Kunde inte hämta fraktpriser',
    none: 'Inga fraktsätt hittades till din adress.',
    toAgent: 'Till ombud',
    toDoor: 'Hem till dörren',
    nearestAgent: 'Närmaste ombud: {agent}',
    inclVat: 'Priserna gäller i dag och inkluderar moms. Qvestium bokar frakten när köpet är betalt.',
    choose: 'Välj fraktsätt',
    chooseAndPay: 'Välj fraktsätt och betala',
    payAmount: 'Betala {amount} kr',
    returnTitle: 'Frakt för att skicka tillbaka {name}',
    swapTitle: 'Frakt för dina plagg i bytet',
    openLabel: 'Öppna etiketten',
    openLabelN: 'Etikett {n}',
    labelReadyInfo: 'Frakten är bokad och betald. Skriv ut etiketten eller visa den hos ombudet, och lämna in paketet.',
    labelPending: 'Frakten är bokad. Etiketten dyker upp här inom några minuter, och du får ett mejl.',
    dropOffAt: 'Lämna in: {agent}',
    pickUpAt: 'Hämtas ut hos: {agent}',
    trackingNumber: 'Spårningsnummer: {number}',
    track: 'Följ paketet',
    status: {
      booking: 'Frakten bokas …',
      bookingFailed: 'Bokningen av frakten dröjer. Vi har fått en signal och ordnar det — du behöver inte göra något.',
      booked: 'Bokad',
      shipped: 'Skickad',
      in_transit: 'På väg',
      delivered: 'Levererad',
      exception: 'Behöver kontrolleras',
      cancelled: 'Avbokad',
    },
  },
  cartModal: {
    paymentServerUnreachable: 'Kunde inte nå betalningsservern',
    title: 'Din korg ({count})',
    confirmTitle: 'Bekräfta beställning',
    processing: 'Bearbetar...',
    empty: 'Korgen är tom',
    creatingPayment: 'Skapar betalning...',
    redirectingToStripe: 'Du skickas till Stripe för säker betalning',
    reviewOrder: 'Granska din beställning innan betalning:',
    rentMonths: { one: 'Hyra {count} mån', other: 'Hyra {count} mån' },
    payNow: 'Att betala nu',
    monthlyAfter: 'Månadsvis därefter',
    secureStripe: 'Säker betalning via Stripe',
    stripeInfo: 'Din kortinformation hanteras säkert av Stripe. Vi lagrar aldrig dina kortuppgifter.',
    payAmount: 'Betala {amount} kr',
    uniqueItem: 'Unikt plagg',
    buyNoBinding: 'Köp — engångspris, ingen bindningstid',
    delivery: 'Leverans:',
    pickup: 'Hämta',
    shippingCost: 'Frakt ({amount} kr)',
    insuranceName: 'Hyresförsäkring',
    insuranceVia: '{name} via Omocom',
    fetchingPrice: 'hämtar pris…',
    insuranceQuote: { one: '{premium} kr för {count} mån, gäller upp till {insured} kr', other: '{premium} kr för {count} mån, gäller upp till {insured} kr' },
    insuranceInfo: 'Täcker skador och stöld under hyran, så slipper du stå för hela värdet själv.',
    buyOneTime: 'Köp (engångspris)',
    rentLabel: 'Hyra',
    rentFirstMonth: '(1:a månaden)',
    shipping: 'Frakt',
    insuranceNote: '(Omocom, hela hyrestiden)',
    buyerProtection: 'Köparskydd',
    buyerProtectionNote: '(pengarna hålls tills du fått plagget)',
    termsNote: 'Första månaden betalas nu. Därefter dras hyran månadsvis från ditt kort under hela bindningstiden, räknat från dagen plagget levereras. När bindningstiden är slut lämnar du tillbaka plagget.',
    fetchingInsurancePrice: 'Hämtar försäkringspris…',
    goToCheckout: 'Gå till kassan',
  },
  copyField: {
    copied: 'Kopierat',
    copy: 'Kopiera',
  },
  oAuthConsentModal: {
    title: 'Anslut till Qvestium',
    description: '{client} vill agera som dig på Qvestium: söka plagg, hantera dina annonser, lägga bud och föreslå byten, läsa och skicka meddelanden och sköta returer. Betalningar gör du alltid själv.',
    redirectNotice: 'Svaret skickas till {host}. Godkänn bara om du själv just försökte ansluta. Du kan återkalla åtkomsten under Profil → Agenter (MCP).',
    deny: 'Neka',
    allow: 'Tillåt',
    logInToContinue: 'Logga in för att fortsätta',
    loggedInAs: 'Inloggad som {email}',
  },
  pushPrompt: {
    title: 'Få notiser från Qvestium',
    body: 'Vi säger till när du får ett meddelande eller bud, när någon köper eller hyr ditt plagg och när något händer i dina affärer.',
    enable: 'Slå på notiser',
    notNow: 'Inte nu',
  },
  pushSettings: {
    title: 'Notiser',
    appOnly: 'Notiser skickas till Qvestium-appen på iPhone. Inställningarna gäller där.',
    deniedHint: 'Notiser är avstängda för Qvestium i telefonens inställningar (Inställningar → Notiser → Qvestium).',
    typeMessages: 'Meddelanden',
    typeDeals: 'Affärer – bud, köp, frakt, byten och utbetalningar',
    typeRentals: 'Hyror och återlämningar',
    typeSupport: 'Svar från kundtjänst',
    quietHours: 'Tysta timmar',
    essentialNote: 'Påminnelser om att bekräfta mottagande, lämna tillbaka ett hyrt plagg eller betala en hyra skickas alltid.',
    saved: 'Sparat',
  },
  agentsMcpCard: {
    tokenPlaceholder: '<ditt-token>',
    createFailed: 'Kunde inte skapa token',
    revokeConfirm: 'Återkalla "{name}"? Agenter som använder det förlorar åtkomsten direkt.',
    revokeFailed: 'Kunde inte återkalla',
    hints: {
      claudeAi: 'I Claude (webb eller app): Inställningar → Connectors → Lägg till anpassad connector. Klistra in adressen, klicka Anslut och godkänn på Qvestium. Inget token behövs — kopplingen syns under Aktiva tokens och kan återkallas där.',
      claudeCode: 'Kör i terminalen. Starta sedan Claude Code och fråga t.ex. "hitta en ullkappa i storlek M under 800 kr".',
      claudeDesktop: 'Lägg till i claude_desktop_config.json (Inställningar → Utvecklare → Redigera konfiguration) och starta om Claude. Kräver Node.js.',
      generic: 'För klienter som stödjer MCP över HTTP (t.ex. Cursor och VS Code). Namnet på filen och nyckeln kan skilja sig mellan klienter.',
    },
    title: 'Agenter (MCP)',
    intro: 'Låt en AI-agent, t.ex. Claude, använda Qvestium åt dig via {mcp} (Model Context Protocol). Agenten kan söka plagg, lägga upp och ändra dina annonser, lägga bud, föreslå byten, svara på meddelanden och sköta returer — som du, med samma regler som här. Betalningar gör du alltid själv: agenten ger dig en betalningslänk. Agenter får aldrig adminbehörighet.',
    claudeAiNote: 'Med {claudeAi} räcker serveradressen nedan — du loggar in och godkänner direkt. Andra klienter behöver ett åtkomsttoken.',
    step1: '1. Skapa ett åtkomsttoken (inte för Claude.ai)',
    copyNow: 'Kopiera tokenet nu — det visas bara en gång. Behandla det som ett lösenord.',
    done: 'Klar',
    namePlaceholder: 'Namn, t.ex. Claude',
    createToken: 'Skapa token',
    step2: '2. Anslut din agent',
    serverAddress: 'Serveradress:',
    otherClients: 'Andra klienter',
    activeTokens: 'Aktiva tokens',
    noneYet: 'Inga ännu.',
    tokenMetaUsed: 'Skapat {created} · använt {used}',
    tokenMetaNeverUsed: 'Skapat {created} · aldrig använt',
    revoke: 'Återkalla',
  },
  profileView: {
    shippingNamePlaceholder: 'Namn på paket (för- och efternamn)',
    phonePlaceholder: 'Mobilnummer',
    shippingDetailsHint: 'Namn, adress och mobilnummer används på fraktetiketten och för avisering när du köper eller säljer med frakt. Visas inte för andra.',
    identity: {
      verified: 'Klart — du är verifierad med BankID.',
      test: 'Testverifiering klar (Iduras testmiljö). Den räknas inte som en riktig verifiering.',
      cancelled: 'Verifieringen avbröts.',
      failed: 'Verifieringen misslyckades. Försök igen.',
      expired: 'Verifieringen tog för lång tid. Försök igen.',
      startFailed: 'Kunde inte starta verifieringen',
      verifiedBadge: '✓ Verifierad med BankID',
      verifiedWithName: '✓ Verifierad med BankID — {name}',
      testVerified: 'Testverifierad i Iduras testmiljö. En riktig verifiering görs med ditt vanliga BankID när tjänsten är i drift.',
      testVerifiedWithName: 'Testverifierad ({name}) i Iduras testmiljö. En riktig verifiering görs med ditt vanliga BankID när tjänsten är i drift.',
      intro: 'Verifiera dig en gång med BankID. Det gör Qvestium tryggare för alla och krävs för att hyra plagg. Vi sparar inte ditt personnummer.',
      verifyButton: 'Verifiera med BankID',
    },
    connectStartFailed: 'Kunde inte starta anslutningen — försök igen om en stund',
    avatarUploadFailed: 'Kunde inte ladda upp profilbilden',
    bodyPhotosUploadFailed: 'Kunde inte ladda upp bilderna',
    bodyPhotoRemoveFailed: 'Kunde inte ta bort bilden',
    uploadAvatar: 'Ladda upp profilbild',
    displayNamePlaceholder: 'Namn som visas',
    editProfile: 'Redigera profil',
    logOut: 'Logga ut',
    measurementsTitle: 'Mått & Storlek',
    clothingSize: 'Klädstorlek',
    bustCm: 'Bröst (cm)',
    waistCm: 'Midja (cm)',
    hipCm: 'Höft (cm)',
    cmValue: '{value} cm',
    stylePrefsTitle: 'Stilpreferenser',
    noStylePrefs: 'Inga preferenser sparade',
    favoriteBrandsTitle: 'Favoritmärken',
    addBrandPlaceholder: 'Lägg till märke...',
    noBrands: 'Inga märken sparade',
    aboutMeTitle: 'Om mig',
    bioPlaceholder: 'Berätta om din modestil...',
    noBio: 'Ingen beskrivning ännu',
    addressTitle: 'Adress',
    streetPlaceholder: 'Gatuadress',
    postalCodePlaceholder: 'Postnummer',
    cityPlaceholder: 'Ort',
    countryPlaceholder: 'Land',
    areaCaption: 'Andra användare ser bara det ungefärliga området i cirkeln, aldrig din adress.',
    addressNotOnMap: 'Adressen kunde inte visas på kartan — kontrollera postnummer och ort.',
    noAddress: 'Ingen adress sparad',
    identityTitle: 'Identitet',
    starting: 'Startar...',
    payoutTitle: 'Utbetalningskonto',
    payoutReady: '✓ Klart — du kan ta emot utbetalningar automatiskt',
    payoutIncomplete: 'Din anslutning är inte klar än — fortsätt registreringen hos Stripe för att kunna få automatiska utbetalningar när dina sålda/uthyrda plagg bekräftas levererade.',
    payoutIntro: 'Anslut ett utbetalningskonto för att få betalt automatiskt när dina sålda/uthyrda plagg bekräftas levererade.',
    continueConnect: 'Fortsätt anslutningen',
    connectPayout: 'Anslut utbetalningskonto',
    bodyPhotosTitle: 'Helkroppsbilder',
    uploadBodyPhoto: '+ Ladda upp bild',
    bodyPhotosIntro: 'Ladda upp bilder på dig själv i helkropp — de kan användas som modellbild när AI genererar "på modell"-bilder för dina plagg, istället för en generisk AI-modell.',
    noBodyPhotos: 'Inga bilder uppladdade ännu',
    saveProfile: 'Spara profil',
    adminBadge: 'ADMIN',
  },
  erbjudPlaggView: {
    imageUploadFailed: 'Bilduppladdning misslyckades',
    mustBeLoggedIn: 'Du måste vara inloggad',
    fillRequired: 'Fyll i alla obligatoriska fält',
    loginTitle: 'Logga in för att erbjuda plagg',
    loginSubtitle: 'Du behöver ett Qid-konto för att publicera kollektioner',
    interestedTitle: 'Intresserad av att sälja?',
    interestedBody: 'Kontakta oss på {email} för att bli godkänd säljare på Qvestium.',
    title: 'Publicera kollektion',
    fields: {
      title: 'Titel *',
      subtitle: 'Underrubrik',
      location: 'Plats *',
      region: 'Region',
      brand: 'Varumärke',
      designer: 'Designer',
      style: 'Stil',
      season: 'Säsong',
      price: 'Pris *',
      priceUnit: 'Prisenhet',
      spotsTotal: 'Antal plagg tillgängliga',
      contactEmail: 'Kontakt-e-post',
      image: 'Bild-URL eller ladda upp',
      highlights: 'Höjdpunkter (max 3)',
      includes: 'Vad ingår (max 3)',
    },
    placeholders: {
      title: 'Kollektionens namn',
      subtitle: 'Kort tagline',
      description: 'Beskriv kollektionen...',
      location: 'Stockholm, Sverige',
      region: 'Skandinavien',
      brand: 'Ditt märke',
      designer: 'Designerns namn',
      season: 'VÅR/SOMMAR 2025',
      contactEmail: 'kontakt@email.se',
      highlight: 'Höjdpunkt {n}',
      include: 'Ingår {n}',
    },
    priceUnits: {
      perItem: 'kr/plagg',
      perSet: 'kr/set',
      perDress: 'kr/klänning',
      perSuit: 'kr/kostym',
    },
    featured: 'Markera som utvald kollektion',
    published: 'Kollektion publicerad!',
    publishing: 'Publicerar...',
  },
  adminView: {
    statsLoadFailed: 'Kunde inte hämta statistik',
    check: {
      noUpdate: 'Ingen statusuppdatering från Bring ännu',
      alreadyUpdated: 'Redan uppdaterad sedan tidigare koll',
      newStatus: 'Ny status: {status}',
      unknown: 'okänd',
      failed: 'Kunde inte kontrollera sändningen',
    },
    txLoadFailed: 'Kunde inte hämta transaktioner',
    csv: {
      filename: 'qvestium-bokforing-{from}-{to}.csv',
      all: 'alla',
      now: 'nu',
      date: 'Datum',
      type: 'Typ',
      status: 'Status',
      item: 'Plagg',
      seller: 'Säljare',
      buyer: 'Köpare',
      price: 'Pris (kr)',
      commission: 'Provision (kr)',
      protection: 'Köparskydd (kr, inkl. moms)',
      shipping: 'Frakt (kr)',
      payout: 'Utbetalning (kr)',
    },
    typeBuy: 'Köp',
    typeRental: 'Uthyrning',
    tabs: {
      dashboard: 'Dashboard',
      operations: 'Drift',
      tickets: 'Ärenden',
      ticketsCount: 'Ärenden ({count})',
      transactions: 'Transaktioner',
      crm: 'CRM',
      marketing: 'Marknadsföring',
      accounting: 'Bokföring',
      offerItems: 'Erbjud plagg',
    },
    title: 'Admin',
    subtitle: 'Kommersiell översikt, transaktioner och bokföring',
    loadingStats: 'Laddar statistik...',
    kpi: {
      users: 'Registrerade användare',
      activeListings: 'Aktiva annonser',
      activeRentals: 'Pågående uthyrningar',
      totalOrders: 'Totalt antal ordrar',
      pendingShipments: 'Väntar på leverans',
      gmv: 'GMV (bruttoomsättning)',
      revenue: 'Qvestium-intäkt',
      ofWhichProtection: 'varav köparskydd',
      sellerPayouts: 'Utbetalt till säljare',
    },
    accountingIntro: 'Välj ett datumintervall och exportera transaktionerna som CSV för bokföring/redovisning.',
    from: 'Från',
    to: 'Till',
    allStatuses: 'Alla statusar',
    fetching: 'Hämtar...',
    refresh: 'Uppdatera',
    exportCsv: 'Exportera CSV ({count})',
    totals: {
      revenue: 'Summa omsättning: {amount}',
      commission: 'Summa provision: {amount}',
      protection: 'Summa köparskydd: {amount}',
      payouts: 'Summa utbetalt: {amount}',
    },
    noTransactions: 'Inga transaktioner för valda filter',
    table: {
      date: 'Datum',
      item: 'Plagg',
      type: 'Typ',
      status: 'Status',
      commission: 'Provision',
      payout: 'Utbetalning',
    },
    checking: 'Kollar...',
    checkNow: 'Kontrollera nu',
  },
  offPlatformWarning: {
    text: 'Det här meddelandet verkar handla om betalning utanför Qvestium. Betala aldrig utanför plattformen — då gäller inte köparskyddet och vi kan inte hjälpa dig om något går fel.',
  },
  chatItemCard: {
    viewListing: 'Visa annonsen',
  },
  messagesView: {
    translate: 'Översätt',
    translating: 'Översätter…',
    showOriginal: 'Visa original',
    showTranslation: 'Visa översättning',
    translatedNote: 'Översatt automatiskt',
    translateFailed: 'Kunde inte översätta meddelandet',
    loadConversationsFailed: 'Kunde inte hämta meddelanden',
    interestedPrefill: 'Hej! Jag är intresserad av {item}. ',
    loadConversationFailed: 'Kunde inte hämta konversationen',
    sendFailed: 'Meddelandet kunde inte skickas',
    confirmBlock: 'Blockera {name}? Ni kan då inte skicka meddelanden till varandra.',
    actionFailed: 'Åtgärden misslyckades',
    empty: 'Inga meddelanden än. Öppna en annons och välj {action} för att starta en konversation.',
    emptyAction: 'Skicka meddelande till säljaren',
    youPrefix: 'Du: {body}',
    regarding: 'Angående: {item}',
    unblock: 'Häv blockering',
    block: 'Blockera',
    keepOnPlatform: 'Håll affären i Qvestium — betala bara via kassan, så gäller köparskyddet.',
    report: 'Anmäl',
    firstMessage: 'Skriv ditt första meddelande till {name}.',
    youBlocked: 'Du har blockerat {name}. Häv blockeringen för att skriva.',
    inputPlaceholder: 'Skriv ett meddelande…',
    title: 'Meddelanden',
    selectConversation: 'Välj en konversation.',
    reportTargetName: 'meddelande från {name}',
  },
  supportTicketModal: {
    loadFailed: 'Kunde inte ladda formuläret',
    chooseCategory: 'Välj en kategori',
    submitFailed: 'Något gick fel — försök igen',
    titleReportListing: 'Anmäl annonsen',
    titleReportIllegal: 'Anmäl olagligt innehåll',
    titleContact: 'Kontakta oss',
    thanks: 'Tack! Ditt ärendenummer är {number}.',
    confirmationReport: 'Vi har skickat en bekräftelse till {email}. En person i vårt team granskar anmälan och meddelar dig beslutet.',
    confirmationSupport: 'Vi har skickat en bekräftelse till {email}. Vi svarar så snart vi kan, oftast inom en arbetsdag.',
    regarding: 'Gäller: {name}',
    reportIntro: 'Beskriv vad som är fel och varför, så granskar vi det. Uppgifterna används bara för att hantera anmälan.',
    choose: 'Välj…',
    whatsWrong: 'Vad är fel?',
    howCanWeHelp: 'Hur kan vi hjälpa dig?',
    yourEmail: 'Din e-post (så att vi kan svara)',
    nameOptional: 'Namn (valfritt)',
    sendReport: 'Skicka anmälan',
  },
  ticketStatus: {
    open: 'Ny',
    inProgress: 'Pågående',
    closed: 'Stängd',
  },
  adminTicketsView: {
    agent: {
      title: 'Agentens förslag',
      hasDraft: 'Agenten har skrivit ett svarsutkast',
      working: 'Agenten skriver ett svarsutkast …',
      failed: 'Agenten kunde inte skriva ett utkast: {error}',
      retry: 'Kör igen',
      use: 'Använd utkast',
      inUse: 'Utkastet ligger i svarsrutan',
      useHint: 'Läs igenom och ändra vid behov, tryck sedan Skicka svar.',
      reject: 'Avslå',
      rejected: 'Utkastet avslogs.',
      requeued: 'Agenten skriver ett nytt utkast.',
      reasoning: 'Agentens motivering: {text}',
      notApprover: 'Bara Agnes och Lars kan godkänna agentens utkast.',
      decided: {
        approved: 'Agentens utkast skickades oförändrat av {by}.',
        edited: 'Agentens utkast skickades med ändringar av {by}.',
        rejected: 'Agentens utkast avslogs av {by}.',
      },
      actions: {
        none: 'Inget mer behövs',
        refund: 'Föreslår återbetalning',
        contact_seller: 'Föreslår kontakt med motparten',
        escalate: 'Osäker — granska noga',
        close: 'Föreslår att ärendet stängs',
      },
    },
    loadFailed: 'Kunde inte hämta ärenden',
    actionFailed: 'Åtgärden misslyckades',
    noteSaved: 'Anteckningen är sparad.',
    replySent: 'Svaret är skickat till {email}.',
    promptReportDecision: 'Beslut — skickas till den som anmälde (t.ex. "Annonsen är borttagen" eller "Annonsen bryter inte mot villkoren"):',
    promptClosingMessage: 'Avslutande meddelande till användaren (lämna tomt för att stänga utan mejl):',
    ticketClosed: 'Ärendet är stängt.',
    promptRemoveListing: 'Ta bort annonsen "{name}"?\n\nSkälet skickas till annonsens ägare:',
    removedInternalNote: 'Annonsen togs bort. Skäl till ägaren: {reason}',
    listingRemovedNotice: 'Annonsen är borttagen och ägaren har fått mejl. Stäng ärendet för att meddela anmälaren beslutet.',
    removeFailed: 'Kunde inte ta bort annonsen',
    filters: {
      active: 'Att hantera',
      closed: 'Stängda',
      all: 'Alla',
    },
    empty: 'Inga ärenden här.',
    kinds: {
      report: 'Anmälan',
      dispute: 'Tvist',
      support: 'Support',
    },
    selectTicket: 'Välj ett ärende.',
    reportFrom: 'Anmälan från {reporter}',
    supportFrom: 'Supportärende från {reporter}',
    loggedIn: '(inloggad)',
    notLoggedIn: '(ej inloggad)',
    concernsListing: 'Gäller annonsen {name}',
    concernsUser: 'Gäller användaren {name}',
    targetStatus: '(status: {status})',
    statusRemoved: 'borttagen',
    removeListing: 'Ta bort annonsen',
    internalNote: 'Intern anteckning',
    replyToUser: 'Svar till användaren',
    internalNotePlaceholder: 'Intern anteckning (syns bara för admin)',
    replyPlaceholder: 'Svar till {email}',
    internalNoteCheckbox: 'Intern anteckning (skickas inte)',
    saveNote: 'Spara anteckning',
    sendReply: 'Skicka svar',
    markedInProgress: 'Markerat som pågående.',
    markInProgress: 'Markera pågående',
    closeWithDecision: 'Stäng med beslut…',
    closeTicket: 'Stäng ärendet…',
    decision: 'Beslut: {resolution}',
    reopened: 'Ärendet är öppnat igen.',
    reopen: 'Öppna igen',
  },
  issueLabels: {
    stuckPayment: 'Betalning fastnat',
    notShipped: 'Inte skickat',
    notHandedOver: 'Inte överlämnat',
    cancelDispute: 'Tvist om avbrytet',
    notDelivered: 'Inte levererat',
    payoutFailed: 'Utbetalning misslyckades',
    payoutWaiting: 'Utbetalning väntar',
  },
  adminActionLabels: {
    removeListing: 'Tog bort annons',
    restoreListing: 'Återställde annons',
    blockUser: 'Spärrade konto',
    unblockUser: 'Hävde spärr',
    cancelTransaction: 'Avbröt affär',
    retryPayout: 'Nytt utbetalningsförsök',
  },
  adminDriftView: {
    loadFailed: 'Kunde inte hämta driftdata',
    actionFailed: 'Åtgärden misslyckades',
    reasonPrompt: '{question}\n\nSkälet skickas till användaren och sparas i loggen:',
    cancelPaidQuestion: 'Avbryt affären om "{name}" och återbetala {amount} kr till köparen?',
    cancelUnpaidQuestion: 'Avbryt den obetalda affären om "{name}"?',
    removeListingQuestion: 'Ta bort annonsen "{name}" ({userId})?',
    listingRemoved: '"{name}" är borttagen och ägaren har fått mejl.',
    blockConfirm: 'Spärra {userId}? Alla annonser döljs och väntande bud avbryts.',
    userBlocked: '{userId} är spärrad.',
    searchFailed: 'Sökningen misslyckades',
    needsAction: 'Kräver åtgärd',
    needsActionCount: 'Kräver åtgärd ({count})',
    noIssues: 'Inga ärenden just nu.',
    unknownItem: 'Okänt plagg',
    parties: 'Säljare {seller} · Köpare {buyer} · {id}',
    cancelAndRefund: 'Avbryt och återbetala',
    retryPayout: 'Försök betala ut igen',
    sellerIsRight: 'Säljaren har rätt – betala ut',
    moderation: 'Moderering av annonser',
    searchPlaceholder: 'Sök på plaggnamn, e-post eller id',
    showRemoved: 'Visa borttagna',
    searching: 'Söker...',
    search: 'Sök',
    noResults: 'Inga träffar.',
    removedReason: 'Borttagen: {reason}',
    listingRestored: '"{name}" är återställd.',
    restore: 'Återställ',
    blockOwner: 'Spärra ägaren…',
    blockedAccounts: 'Spärrade konton ({count})',
    emailPlaceholder: 'E-postadress',
    reasonPlaceholder: 'Skäl (skickas till användaren)',
    block: 'Spärra',
    blockedMeta: '{reason} · {date} av {admin}',
    unblockConfirm: 'Häva spärren för {userId}?',
    unblocked: 'Spärren för {userId} är hävd.',
    unblock: 'Häv spärr',
    recentActions: 'Senaste åtgärder',
    noActions: 'Inga åtgärder ännu.',
  },
  editCollectionModal: {
    imageUploadFailed: 'Bilduppladdning misslyckades',
    title: 'Redigera kollektion',
    fields: {
      title: 'Titel *',
      subtitle: 'Underrubrik',
      location: 'Plats',
      region: 'Region',
      brand: 'Varumärke',
      designer: 'Designer',
      season: 'Säsong',
      style: 'Stil',
      priceUnit: 'Prisenhet',
      spotsTotal: 'Totalt antal',
      spotsAvailable: 'Tillgängliga',
      status: 'Status',
      imageUrl: 'Bild-URL',
      highlights: 'Höjdpunkter',
      includes: 'Ingår',
    },
    priceUnits: {
      perItem: 'kr/plagg',
      perSet: 'kr/set',
      perDress: 'kr/klänning',
      perSuit: 'kr/kostym',
    },
    statuses: {
      active: 'Aktiv',
      soldOut: 'Slutsåld',
      draft: 'Utkast',
    },
    highlightPlaceholder: 'Höjdpunkt {n}',
    includesPlaceholder: 'Ingår {n}',
    featured: 'Utvald kollektion',
  },
  fortnox: {
    title: 'Bokföring i Fortnox',
    intro: 'Varje dag blir en verifikation för inbetalningar, en för utbetalningar till säljare och en för återbetalningar. Inget bokförs två gånger. Stripes avgifter och Stripes utbetalningar till banken bokförs som förut, utanför Qvestium.',
    notConfigured: 'Fortnox är inte konfigurerat på servern (FORTNOX_CLIENT_ID, FORTNOX_CLIENT_SECRET, FORTNOX_REDIRECT_URI och SETTINGS_ENCRYPTION_KEY).',
    connect: 'Koppla Fortnox',
    connecting: 'Öppnar Fortnox…',
    connectHint: 'Om du redan är inloggad i Fortnox kan kopplingen nekas — öppna då Qvestium i ett privat fönster och koppla igen.',
    connected: 'Kopplat till {company}',
    connectedUnknown: 'Kopplat till Fortnox',
    disconnect: 'Koppla från',
    confirmDisconnect: 'Koppla från Fortnox? Inget som redan bokförts påverkas.',
    resultOk: 'Fortnox är kopplat.',
    resultDenied: 'Kopplingen avbröts i Fortnox.',
    resultFailed: 'Det gick inte att koppla Fortnox. Försök igen.',
    resultInvalidState: 'Kopplingen tog för lång tid eller var ogiltig. Försök igen.',
    settings: 'Konton och verifikationsserie',
    series: 'Verifikationsserie',
    save: 'Spara',
    saved: 'Sparat.',
    resetDefaults: 'Standardkonton',
    check: 'Kontrollera mot Fortnox',
    checkOk: 'Serien och alla konton finns i Fortnox.',
    accounts: {
      cash: 'Stripe-saldo (fordran)',
      sellerLiability: 'Skuld till säljare/uthyrare',
      insuranceLiability: 'Skuld till Omocom (försäkring)',
      protectionFeeRevenue: 'Intäkt köparskydd (25 %)',
      commissionRevenue: 'Intäkt provision hyra (25 %)',
      featureRevenue: 'Intäkt utvalda annonser (25 %)',
      shippingRevenue: 'Intäkt frakt byten/returer (25 %)',
      outputVat: 'Utgående moms 25 %',
    },
    autoBook: 'Bokför automatiskt varje natt',
    autoBookHint: 'Gårdagens händelser bokförs efter klockan 03 och en sammanfattning mejlas till admin. Äldre händelser bokför du själv här.',
    autoBookLast: 'Senast bokförd dag: {day}',
    autoBookOn: 'Nattlig bokföring är påslagen.',
    autoBookOff: 'Nattlig bokföring är avstängd.',
    backfill: 'Läs in tidigare affärer',
    backfillDone: { one: '{count} tidigare händelse inläst.', other: '{count} tidigare händelser inlästa.' },
    backfillNote: { one: '{count} händelse i perioden har uppskattat datum (inläst i efterhand) — kontrollera innan du bokför.', other: '{count} händelser i perioden har uppskattat datum (inlästa i efterhand) — kontrollera innan du bokför.' },
    period: 'Period: {from} – {to}',
    toBook: 'Att bokföra',
    nothingToBook: 'Inget att bokföra i perioden.',
    book: { one: 'Bokför {count} verifikation i Fortnox', other: 'Bokför {count} verifikationer i Fortnox' },
    booking: 'Bokför…',
    confirmBook: { one: 'Bokföra {count} verifikation i Fortnox? Det går inte att ångra här.', other: 'Bokföra {count} verifikationer i Fortnox? Det går inte att ångra här.' },
    bookedResult: { one: '{count} verifikation bokförd.', other: '{count} verifikationer bokförda.' },
    errorsResult: { one: '{count} fick fel — se nedan.', other: '{count} fick fel — se nedan.' },
    booked: 'Bokfört i perioden',
    retry: 'Försök igen',
    category: { in: 'Inbetalningar', out: 'Utbetalningar', refund: 'Återbetalningar' },
    status: { booking: 'Bokförs…', booked: 'Bokförd', error: 'Fel' },
    account: 'Konto',
    text: 'Text',
    debit: 'Debet',
    credit: 'Kredit',
    showRows: 'Visa rader',
    hideRows: 'Dölj rader',
    loadFailed: 'Kunde inte hämta bokföringen',
  },
  bgRemoval: {
    remove: 'Ta bort bakgrund',
    useStored: 'Använd frilagd',
    showOriginal: 'Visa original',
    title: 'Ta bort bakgrund',
    before: 'Original',
    after: 'Frilagd',
    downloading: 'Laddar ner bildmodellen första gången… {percent} %',
    downloadingStart: 'Laddar ner bildmodellen första gången…',
    working: 'Tar bort bakgrunden…',
    hint: 'Allt sker i din webbläsare. Originalbilden sparas alltid och du kan byta tillbaka när du vill.',
    useCutout: 'Använd frilagd',
    keepOriginal: 'Behåll original',
    saving: 'Sparar…',
    error: 'Det gick inte att ta bort bakgrunden just nu. Originalbilden används.',
    timeout: 'Det tog för lång tid att ta bort bakgrunden. Originalbilden används.',
    saveError: 'Kunde inte spara den frilagda bilden. Originalbilden används.',
    close: 'Stäng',
  },
  aiImageGenerator: {
    partialErrors: 'Vissa varianter kunde inte genereras: {errors}',
    failed: 'AI-bildgenerering misslyckades',
    intro: 'Skapa en bild av plagget på modell',
    generating: 'Genererar... (kan ta ~30s)',
    generate: 'Generera AI-bilder',
    modelPhotoLabel: 'Modellbild för "på modell":',
    aiModelTitle: 'AI-genererad modell',
    aiModel: 'AI-modell',
    addSelected: { one: 'Lägg till {count} vald i bildgalleriet', other: 'Lägg till {count} valda i bildgalleriet' },
  },
  addProductModal: {
    imageUploadFailed: 'Bilduppladdning misslyckades',
    nameRequired: 'Namn krävs',
    invalidPrice: 'Ange ett giltigt pris',
    title: 'Nytt plagg / accessoar',
    nameLabel: 'Namn *',
    namePlaceholder: 'T.ex. Silkesblus sommar 2025',
    descriptionPlaceholder: 'Kort beskrivning av plagget...',
    purchasePriceLabel: 'Köppris (kr) *',
    rentalPriceLabel: 'Hyrpris per månad, per bindningstid',
    perMonthPlaceholder: 'kr/mån',
    prefillHint: 'Förifyllda med ett förslag när du anger köppris — ändra fritt.',
    sortOrder: 'Sorteringsordning',
    published: 'Publicerad',
    draftHint: '(annars utkast, syns bara för admin)',
    image: 'Bild',
    imagePlaceholder: 'https://... eller ladda upp nedan',
    previewAlt: 'Preview',
    galleryCount: 'Bildgalleri ({count})',
    inStock: 'I lager',
    create: 'Skapa plagg',
  },
  editProductModal: {
    imageUploadFailed: 'Bilduppladdning misslyckades',
    galleryUploadFailed: 'Galleriuppladdning misslyckades',
    title: 'Redigera produkt',
    nameLabel: 'Namn *',
    purchasePriceLabel: 'Köppris (kr)',
    published: 'Publicerad',
    rentalPriceLabel: 'Hyrpris per månad, per bindningstid',
    perMonthPlaceholder: 'kr/mån',
    conditionLabel: 'Skick (1 = Slitet · 5 = Oanvänd)',
    mainImage: 'Huvudbild',
    imagePlaceholder: 'URL eller ladda upp',
    previewAlt: 'Preview',
    galleryCount: { one: 'Bildgalleri ({count} bild)', other: 'Bildgalleri ({count} bilder)' },
    addImages: '+ Lägg till bilder',
    inStock: 'I lager',
  },
  announcementBar: {
    text: 'Gör din garderob smart! Byt, hyr ut, sälj, köp eller hyr enkelt snygga plagg.',
  },
  promoBanner: {
    title: 'Gör din garderob obegränsad',
    body: 'Byt, hyr och sälj kläder enkelt med vänner och andra användare',
  },
  mapErrorBoundary: {
    failed: 'Kartan kunde inte visas',
  },
  mapFallback: {
    loading: 'Laddar karta…',
  },
  areaPickerModal: {
    geolocationUnsupported: 'Webbläsaren kan inte ange din position',
    locationFailed: 'Kunde inte hämta din position',
    title: 'Välj område',
    hint: 'Klicka på kartan där du vill hitta plagg.',
    within: 'Inom',
    radiusKm: '{km} km',
    locating: 'Hämtar…',
    myPosition: 'Min position',
    dotsHint: 'Punkterna visar ungefär var säljarna finns.',
    sellersInArea: { one: '{count} säljare inom området.', other: '{count} säljare inom området.' },
    showAllSweden: 'Visa hela Sverige',
    showItemsHere: 'Visa plagg här',
  },
  areaFilterChip: {
    withinRadius: 'Inom {radius} km från vald plats',
    clearAreaFilter: 'Ta bort områdesfilter',
  },
  navSearchInput: {
    placeholder: 'Sök efter varumärke, plagg...',
    pickAreaOnMap: 'Välj område på kartan',
  },
  allTabs: {
    items: 'Plagg',
    accessories: 'Accessoarer',
    upcomingDrops: 'Kommande drops',
    myWardrobe: 'Min garderob',
  },
  adminTab: {
    label: 'Admin',
  },
  tabBar: {
    more: 'Mer',
  },
  returnStatusLabels: {
    ordered: 'Beställd',
    activated: 'Aktiverad',
    shipped: 'Skickad',
    received: 'Mottagen',
  },
  swapStatusLabels: {
    pending: 'Väntar',
    accepted: 'Accepterat',
    awaitingHandover: 'Inväntande leverans',
    completed: 'Genomfört',
    rejected: 'Avböjt',
    cancelled: 'Avbrutet',
    disputed: 'Pausat – supporten tittar på det',
  },
  offerStatusLabels: {
    pending: 'Väntar',
    accepted: 'Accepterat — väntar på betalning',
    paid: 'Betalt',
    rejected: 'Avböjt',
    cancelled: 'Avbrutet',
  },
  transactionStatusLabels: {
    awaitingPayment: 'Väntar på betalning',
    pending: 'Väntar på leverans',
    shipped: 'Under leverans',
    delivered: 'Levererad',
    returnRequested: 'Retur begärd',
    returnShipped: 'Retur skickad',
    completed: 'Slutförd',
    returnReceived: 'Returnerad',
    cancelled: 'Avbruten',
    refunded: 'Dubblettbetalning — återbetald',
  },
  getWardrobeGuideMessage: {
    newSwaps: { one: 'Du har {count} nytt bytesförslag att svara på.', other: 'Du har {count} nya bytesförslag att svara på.' },
    showSwaps: 'Visa bytesförslag',
    newOffers: { one: 'Du har {count} nytt bud på plagg att svara på.', other: 'Du har {count} nya bud på plagg att svara på.' },
    showOffers: 'Visa bud',
    pendingSales: { one: '{count} plagg väntar på att skickas iväg.', other: '{count} plagg väntar på att skickas iväg.' },
    showToShip: 'Visa vad som ska skickas',
    emptyWardrobe: 'Din garderob är tom — vill du ladda upp ditt första plagg? Klicka på bildikonen nedan så sköter jag resten!',
    nothingListed: { one: 'Du har {count} plagg i garderoben men inget listat än. Vill du lista något till försäljning eller uthyrning?', other: 'Du har {count} plagg i garderoben men inget listat än. Vill du lista något till försäljning eller uthyrning?' },
    showMyItems: 'Visa mina plagg',
    suggestDrop: 'Snyggt, du har listade plagg! Vill du skapa ett drop och dela det på Instagram/TikTok?',
    createDrop: 'Skapa drop',
    allGood: 'Allt ser bra ut i din garderob just nu! 👍',
  },
  createWardrobeItemFromImage: {
    uploading: 'Laddar upp bilden...',
    analyzing: 'Analyserar plagget...',
    creating: 'Skapar plagget...',
  },
  qChat: {
    welcomeNamed: 'Hej {name}! Jag är Q 👋 Ladda upp bilder på plagg du vill lägga in i garderoben (klicka på bildikonen) så skapar jag dem automatiskt åt dig — med AI-bilder, beskrivning och prisförslag. Eller fråga mig vad du vill!\n\n{greeting}',
    welcome: 'Hej! Jag är Q 👋 Ladda upp bilder på plagg du vill lägga in i garderoben (klicka på bildikonen) så skapar jag dem automatiskt åt dig — med AI-bilder, beskrivning och prisförslag. Eller fråga mig vad du vill!\n\n{greeting}',
    pickItemsForDrop: 'Välj plagg till droppet',
    importNow: 'Importera nu',
    replyFailed: 'Jag kunde inte svara just nu, försök igen om en stund.',
    uploadingAndAnalyzing: 'Laddar upp och analyserar plagget...',
    itemCreated: 'Klart! Jag skapade **{name}** åt dig som ett utkast — {description}\n\nFörslag: {salePrice} kr att sälja, eller {rentPrice} kr/mån att hyra ut. Det är inte publicerat än — kolla in det bland "Egna" och slå på uthyrning/försäljning när du är nöjd!',
    createFailed: 'Något gick fel när jag skulle skapa plagget. Försök igen!',
    importProgress: 'Importerar {done}/{total} plagg...',
    importFailed: 'Importen misslyckades.',
    importDone: { one: 'Klart! Importerade {count} plagg från Vinted. Kolla in dem bland "Egna" i din garderob!', other: 'Klart! Importerade {count} plagg från Vinted. Kolla in dem bland "Egna" i din garderob!' },
    importDoneCapped: { one: 'Klart! Importerade {count} plagg från Vinted (begränsat till {total} plagg per körning — kör importen igen för fler). Kolla in dem bland "Egna" i din garderob!', other: 'Klart! Importerade {count} plagg från Vinted (begränsat till {total} plagg per körning — kör importen igen för fler). Kolla in dem bland "Egna" i din garderob!' },
    importLostContact: 'Tappade kontakt med importen — kolla din garderob för att se hur långt den kom.',
    importStartFailed: 'Kunde inte starta importen.',
    subtitle: 'Din AI-assistent för garderoben',
    copy: 'Kopiera',
    draftNotPublished: 'Utkast · ej publicerat',
    uploadImages: 'Ladda upp bilder på plagg',
    placeholderBusy: 'Q jobbar med dina bilder...',
    placeholder: 'Fråga Q...',
  },
  bulkUploadModal: {
    starting: 'Startar...',
    title: 'Ladda upp flera plagg',
    subtitle: 'Välj så många bilder du vill — Q analyserar varje plagg automatiskt och skapar ett utkast med AI-bilder, beskrivning och prisförslag.',
    chooseImages: 'Välj bilder',
    progress: '{done} av {total} klara',
    waiting: 'Väntar...',
    doneClose: 'Klart, stäng',
    addMoreImages: '+ Lägg till fler bilder',
  },
  returnVerdicts: {
    destroyed: 'Helt förstört',
    destroyedHint: 'Ersättningsvärdet minus hyran du fått',
    heavilyDegraded: 'Kraftigt försämrat',
    heavilyDegradedHint: '50 % av ersättningsvärdet',
    wear: 'Slitage eller fläckar',
    wearHint: '30 % av ersättningsvärdet',
  },
  returnStatusLabel: {
    active: 'Dags att lämna tillbaka',
    awaitingReview: 'Väntar på bedömning av skicket',
    approved: 'Skicket godkänt',
    compensationProposed: 'Kompensation föreslagen',
    compensationAgreed: 'Kompensation överenskommen',
    escalated: 'Hanteras av support',
    handedOver: 'Lämnad — väntar på bekräftelse',
    shippingBooked: 'Frakt bokad',
    completed: 'Avslutad',
  },
  returnPhotoRow: {
    noImages: 'Inga bilder',
  },
  itemReturnCard: {
    paymentStartFailed: 'Kunde inte starta betalningen',
    uploadFailed: 'Uppladdningen misslyckades',
    rentedFrom: 'Hyrt av {name}',
    borrowedFrom: 'Lånat av {name}',
    rentedOutTo: 'Uthyrt till {name}',
    lentTo: 'Utlånat till {name}',
    dueBy: 'åter senast {date}',
    inDays: { one: '(om {count} dag)', other: '(om {count} dagar)' },
    overdue: '(försenad)',
    insuredViaOmocom: 'Försäkrat via Omocom',
    reportDamageOmocom: 'Anmäl skada till Omocom',
    reportDamageLater: 'vid skada kan du även anmäla den till Omocom när återlämningen är klar',
    photoInstructions: 'Fota plagget (minst två bilder, fram och bak) innan du lämnar tillbaka det. Ägaren jämför bilderna med annonsens och godkänner skicket.',
    dropoffAtOwner: 'Lämna på ägarens adress',
    shipWithQrPrice: 'Skicka med QR-kod ({amount} kr)',
    shipWithQrSoon: 'Skicka med QR-kod — kommer snart',
    removePhoto: 'Ta bort bild',
    uploadingShort: 'Laddar…',
    addPhoto: '+ Bild',
    sendingShort: 'Skickar…',
    sendPhotosToOwner: 'Skicka bilderna till ägaren',
    ownerActiveInfo: '{name} får en påminnelse en vecka innan och fotar plagget när det är dags. Du godkänner skicket innan det skickas.',
    listingPhotos: 'Annonsens bilder',
    returnPhotos: 'Vid återlämning',
    awaitingReviewShip: '{name} tittar på bilderna. Vänta med att skicka plagget tills skicket är godkänt.',
    awaitingReviewDropoff: '{name} tittar på bilderna. Vänta med att lämna plagget tills skicket är godkänt.',
    approveCondition: 'Godkänn skicket',
    conditionNotOk: 'Skicket är inte okej',
    replacementValuePlaceholder: 'Ersättningsvärde (kr)',
    notePlaceholder: 'Beskriv vad som är fel — visas för den som hyrt',
    proposedCompensation: 'Föreslagen kompensation: {amount}',
    proposeCompensation: 'Föreslå kompensation',
    assessment: 'Bedömning: {verdict} · kompensation {amount}',
    replacementValue: '(ersättningsvärde {amount} kr)',
    borrowerDecidePrompt: 'Godkänner du förslaget? Om ni inte är överens går ärendet vidare till Qvestiums support.',
    lenderDecidePrompt: 'Står du fast vid förslaget? Båda behöver godkänna — annars går ärendet till support.',
    approve: 'Godkänn',
    escalateConfirm: 'Ärendet skickas till support för bedömning. Fortsätta?',
    disagreeToSupport: 'Inte överens — till support',
    approvedWaitingFor: 'Du har godkänt. Väntar på {name}.',
    payCompensationInfo: 'Betala kompensationen för att gå vidare med återlämningen.',
    payAmount: 'Betala {amount} kr',
    waitingForPayment: 'Väntar på att {name} betalar. Pengarna betalas ut till ditt konto.',
    escalatedInfo: 'Ni var inte överens, eller så har något steg dröjt. Qvestiums support har fått ärendet och hör av sig till er båda.',
    payShippingInfo: 'Betala frakten så får du en QR-kod att visa upp hos ett Bring-ombud — ingen etikett behövs.',
    payShipping: 'Betala frakt {amount} kr',
    dropoffAt: 'Lämna plagget till:',
    markHandedOver: 'Markera som lämnat',
    counterpartShips: '{name} betalar frakten och skickar plagget.',
    counterpartDropsOff: '{name} lämnar plagget på din adress.',
    showQrInfo: 'Visa QR-koden hos ett Bring-ombud och lämna paketet.',
    qrAlt: 'QR-kod för frakt',
    code: 'Kod: {code}',
    shippingBookedInfo: 'Frakten är bokad. Bekräfta när paketet har kommit fram.',
    consignmentNumber: 'Sändningsnummer {number}',
    waitingForReceipt: 'Väntar på att {name} bekräftar att plagget kommit tillbaka.',
    confirmReceived: 'Bekräfta att jag fått tillbaka plagget',
  },
  returnsSection: {
    title: 'Återlämningar',
    completed: 'Avslutade ({count})',
  },
  minGarderobView: {
    confirmDeleteSelected: { one: 'Ta bort {count} plagg från garderoben?', other: 'Ta bort {count} plagg från garderoben?' },
    deleteSelectedFailed: 'Kunde inte ta bort plaggen.',
    confirmCancelDrop: 'Avbryta dropet? Plaggen blir direkt synliga i marknadsplatsen igen (om de är listade).',
    confirmDeleteItem: 'Ta bort plagget från garderoben?',
    loginTitle: 'Logga in för att se din garderob',
    loginSubtitle: 'Här samlas dina köpta, hyrda och egna plagg',
    tabs: {
      all: 'Alla',
      own: 'Egna',
      bought: 'Köpta',
      rented: 'Hyrda',
      forRent: 'För uthyrning',
      forSale: 'Till försäljning',
      liked: 'Gillade',
      outfits: 'Outfits',
      drops: 'Drops',
      toShip: 'Att skicka',
      swaps: 'Bytesförslag',
      offers: 'Bud',
      tracking: 'Spårning',
      returns: 'Returer',
      sales: 'Försäljning',
      reviews: 'Betyg',
    },
    title: 'Min garderob',
    subtitle: 'Dina köpta, hyrda och egna plagg',
    cancelDrop: 'Avbryt drop',
    cancelDelete: 'Avbryt borttagning',
    addDrop: '+ Drop',
    deleteItems: 'Ta bort plagg',
    addAccessories: '+ Lägg till Accessoarer',
    addItem: '+ Lägg till plagg',
    dropSelectHint: 'Markera de plagg som ska vara med i dropet (endast egna plagg kan väljas), klicka sedan på {button} längst ner.',
    deleteSelectHint: 'Markera de plagg du vill ta bort (endast egna plagg kan väljas), klicka sedan på {button} längst ner.',
    next: 'Nästa',
    deleteSelected: 'Ta bort valda',
    deleting: 'Tar bort...',
    selectedCount: { one: '{n} plagg valt', other: '{n} plagg valda' },
    loadingWardrobe: 'Laddar garderob...',
    liked: {
      emptyTitle: 'Inga gillade plagg än',
      emptyText: 'Plagg du gillar i marknadsplatsen dyker upp här',
    },
    toShip: {
      title: 'Att skicka',
      empty: 'Inga plagg att skicka just nu',
      someoneBought: 'Någon har köpt ditt plagg! Skicka det.',
      someoneRented: 'Någon har hyrt ditt plagg! Skicka det.',
      buyer: 'Köpare: {buyer}',
      awaitingBuyerConfirmation: 'Väntar på köparens bekräftelse',
      confirmHandover: 'Bekräfta överlämnat (hämta)',
      pickupHint: 'Köparen hämtar plagget — ingen frakt. Klicka när ni möts och plagget bytt ägare.',
      shipItem: 'Skicka plagg',
    },
    itemFallback: 'Plagg',
    badgeSold: 'Såld',
    badgeRented: 'Uthyrd',
    commission: 'Provision',
    commissionRent: 'Provision (20 %)',
    commissionDeducted: '-{amount} kr',
    yourPayout: 'Din utbetalning',
    yourReply: 'Ditt svar: "{message}"',
    reply: 'Svar: "{message}"',
    sendRejection: 'Skicka avböjande',
    trackingNumber: 'Spårning: {number}',
    swaps: {
      confirmCancel: 'Avbryta bytesförslaget?',
      receivedTitle: 'Mottagna förslag',
      emptyReceived: 'Inga bytesförslag mottagna ännu',
      yourItem: 'Ditt plagg',
      offeredBy: 'Erbjuds av {user}',
      rejectPlaceholder: 'Meddelande till den som föreslog bytet (valfritt)',
      acceptChooseDelivery: 'Acceptera / hämta eller frakt...',
      sentTitle: 'Skickade förslag',
      emptySent: 'Du har inte skickat några bytesförslag ännu',
      newReply: 'Nytt svar',
      theirItem: 'Deras plagg',
      youOffered: 'Du erbjöd',
      cancelProposal: 'Avbryt förslag',
    },
    offers: {
      confirmCancel: 'Avbryta budet?',
      receivedTitle: 'Mottagna bud',
      emptyReceived: 'Inga bud mottagna ännu',
      offerFrom: 'Bud från {name}',
      rejectPlaceholder: 'Meddelande till budgivaren (valfritt)',
      accept: 'Acceptera',
      sentTitle: 'Skickade bud',
      emptySent: 'Du har inte skickat några bud ännu',
      cancelOffer: 'Avbryt bud',
      payAmount: 'Betala {amount} kr',
      payAmountPerMonth: 'Betala {amount} kr/mån',
    },
    tracking: {
      title: 'Aktiva transaktioner',
      empty: 'Inga aktiva transaktioner',
    },
    returns: {
      bagsTitle: 'Returpåsar',
      orderBag: 'Beställ returpåse',
      emptyBags: 'Inga returpåsar ännu',
      stepOrdered: 'Beställd',
      stepActivated: 'Aktiverad',
      stepShipped: 'Skickad',
      stepReceived: 'Mottagen',
    },
    sales: {
      title: 'Mina försäljningar',
      empty: 'Inga försäljningar ännu. Lista dina plagg för uthyrning eller försäljning!',
      status: {
        pending: 'Väntar på leverans',
        shipped: 'Skickad',
        delivered: 'Levererad',
        returnRequested: 'Retur begärd',
        returnShipped: 'Retur skickad',
        completed: 'Slutförd',
        returnReceived: 'Retur mottagen',
      },
    },
    drops: {
      title: 'Mina drops',
      empty: 'Inga drops skapade ännu. Klicka på "+ Drop" för att schemalägga ett släpp.',
      statusLive: 'Live',
      statusCancelled: 'Avbrutet',
      statusScheduled: 'Schemalagt',
      releasedAt: 'Släpptes {date}',
      releasesAt: 'Släpps {date}',
    },
    empty: {
      own: 'Inga egna plagg registrerade',
      bought: 'Inga köpta plagg',
      rented: 'Inga hyrda plagg',
      forRent: 'Inga plagg listade för uthyrning',
      forSale: 'Inga plagg listade till försäljning',
      all: 'Garderoben är tom',
      addClothesHint: 'Lägg till dina kläder och välj att hyra ut eller sälja dem',
      browseHint: 'Bläddra i butiken och börja handla!',
    },
  },
  stars: {
    ariaLabel: '{value} av 5 stjärnor',
  },
  starInput: {
    ariaLabel: 'Betyg',
    starCount: { one: '{count} stjärna', other: '{count} stjärnor' },
  },
  reputationSummary: {
    buys: { one: '{count} köp', other: '{count} köp' },
    swaps: { one: '{count} byte', other: '{count} byten' },
    rents: { one: '{count} hyra', other: '{count} hyror' },
    reviewCount: { one: '({count} betyg)', other: '({count} betyg)' },
    noRatings: 'Inga betyg än',
    memberSince: 'Medlem sedan {date}',
  },
  pendingReviewCard: {
    chooseRating: 'Välj 1–5 stjärnor',
    withCounterparty: 'med {name} · {date}',
    howDidItGo: 'Hur gick affären med {name}?',
    commentPlaceholder: 'Kommentar (valfritt) — visas på användarens profil',
    submit: 'Skicka betyg',
  },
  reviewsSection: {
    toReviewTitle: 'Att betygsätta',
    toReviewText: 'Betygsätt dem du handlat, bytt eller hyrt med. Betyget och kommentaren visas under deras namn.',
    emptyPending: 'Inga affärer att betygsätta just nu',
    yourReputationTitle: 'Ditt omdöme',
    noReviewsReceived: 'Du har inte fått några betyg än.',
  },
  sellerBadge: {
    soldBy: 'Säljs av',
  },
  wardrobeItemDetailPage: {
    errorUpload: 'Kunde inte ladda upp bilderna',
    errorSetPrimary: 'Kunde inte byta huvudbild',
    primaryImage: 'Huvudbild',
    makePrimary: 'Gör till huvudbild',
    uploading: 'Laddar upp...',
    addMoreImages: '+ Lägg till fler bilder',
    addImages: '+ Lägg till bilder',
    sizeLabel: 'Storlek {size}',
    sourceOwn: 'Eget plagg',
    sourceBought: 'Köpt',
    sourceRented: 'Hyrd',
    listedFor: 'Listad för',
    openForSwap: 'Öppen för byte',
    rentalChooseCommitment: 'Uthyrning — välj bindningstid',
    buyerProtectionTotal: '+ köparskydd {fee} kr = {total}',
    buyerProtectionInfo: 'Köparskyddet håller pengarna tills du fått plagget och ger dig pengarna tillbaka om det inte stämmer med annonsen.',
    rentalCommissionInfo: 'Qvestium tar 20 % provision från uthyraren vid uthyrning.',
    replacementValue: 'Ersättningsvärde vid skada: {amount} kr.',
    rent: 'Hyr',
    buyFor: 'Köp {amount} kr',
    messageSeller: 'Skicka meddelande till säljaren',
    proposeSwap: 'Föreslå byte',
    proposeOffer: 'Föreslå köp/hyra',
    swapProposalSent: 'Bytesförslag skickat! Ägaren meddelas.',
    offerSent: 'Bud skickat! Säljaren meddelas.',
    reportListing: 'Anmäl annonsen',
  },
  wardrobeCard: {
    sourceOwn: 'Eget',
    sourceBought: 'Köpt',
    sourceRented: 'Hyrd',
    deliveryStatus: {
      pending: 'Väntar på leverans',
      shipped: 'Under leverans',
      delivered: 'Levererad',
      returnRequested: 'Retur begärd',
      returnShipped: 'Retur skickad',
      completed: 'Slutförd',
      returnReceived: 'Returnerad',
    },
    sold: 'Såld',
    inDrop: '🔒 I droppet "{name}" — släpps {date}',
    sizeShort: 'Stl {size}',
    tracking: 'Spårning: {number}',
    openForSwap: 'Öppen för byte',
    toggleRent: 'Uthyrning',
    toggleSale: 'Till salu',
    confirmReceived: 'Bekräfta mottaget',
    waitingForSeller: 'Väntar på säljaren',
    confirmPickedUp: 'Bekräfta hämtat',
    returnItem: 'Returnera',
  },
  sellerWardrobeCard: {
    sold: 'Såld',
    sizeShort: 'Stl {size}',
    openForSwap: 'Öppen för byte',
    notListed: 'Inte listad',
  },
  sellerProfileView: {
    loadingProfile: 'Laddar profil...',
    approximateArea: 'Ungefärligt område',
    sendMessage: 'Skicka meddelande',
    reviewsHeading: 'Betyg ({count})',
    wardrobeHeading: 'Garderob ({count})',
    emptyWardrobe: 'Inga plagg registrerade ännu',
  },
  dropWizardModal: {
    errorNameRequired: 'Ange ett namn för dropet',
    errorReleaseRequired: 'Ange datum och tid för släppet',
    errorReleaseInPast: 'Släppdatumet måste vara i framtiden',
    createDrop: 'Skapa drop',
    creatingDrop: 'Skapar drop...',
    itemsSelected: { one: '{count} plagg valt', other: '{count} plagg valda' },
    nameLabel: 'Namn på dropet *',
    namePlaceholder: 'T.ex. Höstkollektionen',
    releaseLabel: 'Släpps (datum & tid) *',
  },
  dropAnimationPreview: {
    presents: 'presenterar',
    releases: 'Släpps',
  },
  dropShareBar: {
    copied: 'Kopierad!',
    copyLink: 'Kopiera länk',
    shareNative: 'Dela till Instagram / TikTok m.fl.',
    shareHint: 'Öppna länken på mobilen för att dela direkt till Instagram/TikTok, eller kopiera länken ovan.',
  },
  dropSharePanel: {
    shareText: '{name} — släpps {date} på Qvestium',
    shareDrop: 'Dela dropet',
  },
  dropVideoRecorder: {
    errorCanvasUnsupported: 'Canvas stöds inte',
    presents: 'PRESENTERAR',
    releases: 'Släpps',
    errorEmptyFile: 'Videoinspelningen gav en tom fil — det kan bero på webbläsaren eller att fliken var i bakgrunden. Prova igen med fliken aktiv i förgrunden, eller dela länken ovan istället.',
    errorFailed: 'Videoinspelningen misslyckades',
    title: 'Videoteaser att posta',
    unsupported: 'Videoinspelning stöds inte i den här webbläsaren. Kopiera länken ovan och dela manuellt.',
    recording: 'Spelar in... (ca 8 sek)',
    record: 'Spela in video',
    download: 'Ladda ner video',
    shareVideo: 'Dela video',
  },
  transactionTrackingCard: {
    steps: {
      pending: 'Beställd',
      shipped: 'Skickad',
      delivered: 'Levererad',
      returnRequested: 'Retur begärd',
      returnShipped: 'Retur skickad',
      completed: 'Slutförd',
    },
    enterTrackingNumber: 'Ange ett spårningsnummer',
    itemFallback: 'Plagg',
    yourPayout: 'Din utbetalning',
    deliveryTracking: 'Leveransspårning: {number}',
    returnTracking: 'Returspårning: {number}',
    waitingForBuyer: 'Väntar på köparen',
    confirmHandedOver: 'Bekräfta överlämnat (hämta)',
    trackingPlaceholder: 'Spårningsnummer...',
    shipToBuyer: 'Skicka till köpare',
    waitingForSeller: 'Väntar på säljaren',
    confirmPickedUp: 'Bekräfta hämtat',
    confirmReceived: 'Bekräfta mottaget',
    requestReturn: 'Begär retur',
    returnTrackingPlaceholder: 'Returspårningsnummer...',
    shipReturn: 'Skicka retur',
    confirmReturnReceived: 'Bekräfta retur mottagen',
    claimWindow: 'Kontrollera plagget. Säljaren får betalt {date} om du inte anmäler något.',
    reportProblem: 'Anmäl problem',
    reportPlaceholder: 'Vad är fel? T.ex. att plagget inte kommit fram, har skador eller inte stämmer med annonsen.',
    sendReport: 'Skicka anmälan',
    reportSent: 'Anmälan skickad (ärende {number}). Säljaren får inte betalt medan vi tittar på ärendet.',
    problemReported: 'Du har anmält ett problem. Qvestiums support tittar på ärendet och hör av sig.',
    sellerPayoutDue: 'Utbetalning {date}, om köparen inte anmäler något.',
    sellerProblemReported: 'Köparen har anmält ett problem. Utbetalningen är pausad medan supporten tittar på ärendet.',
    rentPlan: 'Hyra: {paid} av {total} månader betalda',
    rentNext: 'nästa dragning {date}',
    rentPaidOut: 'Utbetalt för {paid} av {total} månader',
    rentActionRequired: 'Månad {month} ({amount} kr) kunde inte dras från ditt kort. Betala inom 7 dagar så fortsätter hyran som vanligt.',
    rentSellerWaiting: 'Hyraren har inte betalat månad {month} än — vi har påmint och hör av oss om det dröjer.',
    payRent: 'Betala {amount} kr',
    cancelPurchase: 'Avbryt köpet',
    cancelConfirm: 'Avbryta köpet av {item}? Du får tillbaka hela beloppet ({amount} kr) till ditt kort inom 5–10 bankdagar.',
    cancelled: 'Köpet är avbrutet. {amount} kr betalas tillbaka till ditt kort.',
    cancelRequestConfirm: 'Be säljaren att avbryta köpet av {item}? Säljaren bekräftar att plagget inte har lämnats över. Svarar säljaren inte inom 72 timmar avbryts köpet och du får tillbaka {amount} kr.',
    cancelRequested: 'Säljaren har fått din begäran. Du får besked inom 72 timmar.',
    cancelRequestPending: 'Du har bett säljaren att avbryta köpet. Svarar säljaren inte inom 72 timmar avbryts det automatiskt.',
    cancelObjected: 'Säljaren säger att plagget redan har lämnats över. Supporten går igenom ärendet.',
    cancelObjectedBySeller: 'Du har sagt att plagget är överlämnat. Supporten går igenom ärendet och hör av sig.',
    sellerCancelRequest: 'Köparen vill avbryta köpet. Har du inte lämnat över plagget? Godkänn, så får köparen pengarna tillbaka. Utan svar inom 72 timmar avbryts köpet.',
    approveCancel: 'Godkänn',
    objectCancel: 'Plagget är överlämnat',
    approveCancelConfirm: 'Avbryta köpet? Köparen får tillbaka pengarna och plagget blir tillgängligt i din garderob igen.',
    objectCancelPrompt: 'Berätta kort när och var plagget lämnades över. Supporten går igenom ärendet.',
    cancelApproved: 'Köpet är avbrutet och köparen får tillbaka pengarna.',
    cancelObjectedSeller: 'Supporten har fått ärendet ({ticket}) och hör av sig.',
  },
  shipToCustomerModal: {
    qrReference: 'Qvestium-order\nOrder: {order}\nPlagg: {item}\nKöpare: {buyer}',
    itemFallback: 'Plagg',
    enterTrackingNumber: 'Ange ett spårningsnummer',
    registerFailed: 'Kunde inte registrera leverans',
    title: 'Skicka plagg',
    buyer: 'Köpare: {buyer}',
    payout: 'Utbetalning: {amount} kr',
    shipmentRegistered: 'Leverans registrerad!',
    buyerNotified: 'Köparen har meddelats.',
    referenceInfo: 'Visa den här koden när du lämnar in plagget hos ett Bring-ombud — den är en referens till din order, inte en fraktetikett. Du får ett spårningsnummer av ombudet, som du anger i nästa steg.',
    orderRef: 'Order {order}',
    droppedOffContinue: 'Jag har lämnat in plagget, fortsätt',
    trackingIntro: 'Ange transportör och spårningsnummer för leveransen till köparen:',
    trackingPlaceholder: 'Spårningsnummer',
    autoPayoutInfo: 'Med transportör angiven kan vi bevaka leveransen automatiskt och betala ut dig direkt när paketet är levererat.',
    registering: 'Registrerar...',
    confirmShipment: 'Bekräfta leverans',
  },
  addWardrobeItemModal: {
    imageUploadFailed: 'Bilduppladdning misslyckades',
    enterName: 'Ange ett namn',
    title: 'Lägg till plagg',
    nameRequired: 'Namn *',
    namePlaceholder: 'T.ex. Svart ullkappa',
    descriptionPlaceholder: 'Material, skick, detaljer...',
    sizePlaceholder: 'M, 38, ...',
    conditionRange: 'Skick (1-5)',
    weight: 'Vikt (för fraktpris)',
    image: 'Bild',
    imageUrlPlaceholder: 'URL eller ladda upp',
    gallery: 'Bildgalleri ({count})',
    listQuestion: 'Vill du lista plagget?',
    sell: 'Sälja',
    currency: 'kr',
    rentOut: 'Hyra ut',
    perMonthPlaceholder: 'kr/mån',
    prefilledHint: 'Förifyllda med ett förslag från säljpriset — ändra fritt.',
    replacementValue: 'Ersättningsvärde (kr)',
    replacementValuePlaceholder: 'Vad plagget är värt',
    replacementValueHint: 'Visas för hyraren. Används för att beräkna kompensation om plagget förstörs eller försämras (100 %, 50 % eller 30 %).',
    feeInfo: 'Försäljning: ingen provision — du får hela priset (köparen betalar köparskydd). Uthyrning: Qvestium tar 20 % provision.',
    submit: 'Lägg till i garderob',
  },
  swapProposalDetailModal: {
    title: 'Bytesförslag',
    yourItem: 'Ditt plagg',
    theirItem: 'Deras plagg',
    offeredBy: 'Erbjuds av {user}',
    youOffered: 'Du erbjöd',
    message: 'Meddelande',
    reply: 'Svar',
    sentAt: 'Skickat {date}',
    updatedAt: 'Uppdaterat {date}',
    rejectPlaceholder: 'Meddelande till den som föreslog bytet (valfritt)',
    sendRejection: 'Skicka avböjande',
    handoverQuestion: 'Hur vill du lämna över ditt plagg?',
    pickup: 'Hämta',
    shippingWithCost: 'Frakt ({amount} kr)',
    accept: 'Acceptera',
    cancelProposal: 'Avbryt förslag',
    meetingPlace: 'Mötesplats (ägarens adress)',
    myItemLabel: 'Ditt plagg ({method}):',
    theirItemLabel: 'Motpartens plagg ({method}):',
    methodShipping: 'frakt',
    methodPickup: 'hämta',
    shippingPaid: 'Frakt betald ✓',
    awaitingShippingPayment: 'Väntar på att du betalar frakt ({amount} kr)',
    awaitingShippingAndProtectionPayment: 'Väntar på att du betalar frakt och köparskydd ({amount} kr)',
    youConfirmedHandover: 'Du har bekräftat överlämning ✓',
    awaitingYourHandover: 'Väntar på att du bekräftar överlämning',
    handledByOther: 'Hanteras av motparten',
    otherConfirmed: 'Motparten har bekräftat ✓',
    waitingForOther: 'Väntar på motparten',
    payShipping: 'Betala frakt ({amount} kr)',
    payShippingAndProtection: 'Betala frakt och köparskydd ({amount} kr)',
    confirmHandover: 'Bekräfta att överlämningen skett',
    confirmReceived: 'Jag har fått plaggen',
    youConfirmedReceived: 'Du har bekräftat att plaggen kommit fram.',
    reportProblem: 'Anmäl ett problem',
    reportPlaceholder: 'Vad stämmer inte? Bytet pausas medan supporten tittar på det.',
    sendReport: 'Skicka anmälan',
    reportSent: 'Anmälan är skickad. Bytet är pausat tills supporten hört av sig.',
  },
  proposeSwapModal: {
    loadFailed: 'Kunde inte hämta din garderob',
    selectAtLeastOne: 'Välj minst ett plagg att erbjuda',
    title: 'Föreslå byte',
    intro: 'Välj de plagg ur din garderob du vill erbjuda mot {item}.',
    loadingWardrobe: 'Laddar din garderob...',
    noItems: 'Du har inga plagg tillgängliga att erbjuda.',
    period: 'Bytesperiod',
    permanentInfo: 'Plaggen byter ägare permanent om förslaget godtas.',
    temporaryInfo: { one: 'Ett tillfälligt byte i {count} månad — kom överens med ägaren om att byta tillbaka när perioden är slut.', other: 'Ett tillfälligt byte i {count} månader — kom överens med ägaren om att byta tillbaka när perioden är slut.' },
    handoverQuestion: 'Hur vill du lämna över dina plagg?',
    pickup: 'Hämta',
    shippingWithCost: 'Frakt ({amount} kr)',
    shippingInfo: 'Du betalar din egen frakt om du väljer det — ägaren väljer sitt sätt när de svarar.',
    protectionInfo: '+ köparskydd {amount} kr (5 % av plaggets värde + 7,50 kr). Bytet slutförs först när båda plaggen kommit fram. Hämtar ni plaggen själva kostar bytet ingenting.',
    messageLabel: 'Meddelande (valfritt)',
    messagePlaceholder: 'Skriv ett meddelande till ägaren...',
    sending: 'Skickar förslag...',
    submit: 'Föreslå byte ({count} valda)',
  },
  proposeOfferModal: {
    invalidOffer: 'Ange ett bud större än 0',
    title: 'Föreslå köp/hyra',
    intro: '{item} är inte listat just nu — lägg ett bud till säljaren.',
    rent: 'Hyr',
    yourOfferBuy: 'Ditt bud (kr)',
    yourOfferRent: 'Ditt bud (kr/mån)',
    pricePlaceholder: 'T.ex. 500',
    messageLabel: 'Meddelande (valfritt)',
    messagePlaceholder: 'Skriv ett meddelande till säljaren...',
    sending: 'Skickar bud...',
    submit: 'Skicka bud',
  },
  editWardrobeItemModal: {
    imageUploadFailed: 'Bilduppladdning misslyckades',
    galleryUploadFailed: 'Galleriuppladdning misslyckades',
    deleteConfirm: 'Ta bort plagget från garderoben?',
    title: 'Redigera plagg',
    name: 'Namn',
    condition: 'Skick',
    weight: 'Vikt (för fraktpris)',
    image: 'Bild',
    gallery: { one: 'Bildgalleri ({count} bild)', other: 'Bildgalleri ({count} bilder)' },
    addImages: '+ Lägg till bilder',
    listing: 'Listning',
    sell: 'Sälja',
    currency: 'kr',
    rentOut: 'Hyra ut',
    perMonthPlaceholder: 'kr/mån',
    replacementValue: 'Ersättningsvärde (kr)',
    replacementValuePlaceholder: 'Vad plagget är värt',
    replacementValueHint: 'Visas för hyraren. Används för att beräkna kompensation om plagget förstörs eller försämras (100 %, 50 % eller 30 %).',
    feeInfo: 'Försäljning: ingen provision — du får hela priset (köparen betalar köparskydd). Uthyrning: Qvestium tar 20 % provision.',
  },
  returnFlowModal: {
    returnRequested: 'Retur begärd! En returpåse har beställts.',
    bagOrdered: 'Returpåse beställd! Kod: {code}',
    enterQrCode: 'Ange QR-koden',
    bagActivated: 'Returpåse aktiverad! Lägg i plagget och lämna in.',
    codeNotFound: 'Koden hittades inte',
    enterTrackingNumber: 'Ange spårningsnummer',
    transactionMissing: 'Transaktion saknas',
    returnShipped: 'Retur skickad! Säljaren meddelas.',
    title: 'Returnera plagg',
    rented: 'Hyrd',
    bought: 'Köpt',
    trackingInstructions: 'Lägg i plagget i påsen, lämna in hos Bring-ombud och ange spårningsnumret:',
    trackingPlaceholder: 'Spårningsnummer',
    later: 'Senare',
    confirmReturnShipment: 'Bekräfta returleverans',
    requestingReturn: 'Begär retur...',
    requestReturn: 'Begär retur (returpåse beställs automatiskt)',
    requestReturnHint: 'En returpåse beställs automatiskt. Du kan också använda en egen påse.',
    orderBag: 'Beställ returpåse',
    haveBagScan: 'Jag har redan en påse — scanna QR',
    orderBagHint: 'Returpåsen skickas hem till dig kostnadsfritt. Lägg i plagget och lämna in.',
    orderBagInfo: 'En returpåse skickas till din registrerade adress. Lägg i plagget, klistra fast etiketten och lämna in hos närmaste Bring-ombud.',
    ordering: 'Beställer...',
    enterBagCode: 'Ange koden på din returpåse (t.ex. QB-A3X7YZ):',
    activating: 'Aktiverar...',
    activateBag: 'Aktivera påse',
  },
  scanActivateButton: {
    codeNotFound: 'Koden hittades inte',
    scanOrEnterCode: 'Scanna QR / Ange kod',
    activate: 'Aktivera',
  },
  shipBagForm: {
    couldNotRegister: 'Kunde inte registrera',
    trackingPlaceholder: 'Ange spårningsnummer...',
    markShipped: 'Markera som skickad',
  },
  publicDropPage: {
    loading: 'Laddar drop...',
    unavailable: 'Det här dropet är inte tillgängligt längre.',
    toQvestium: 'Till Qvestium',
    liveNow: 'Nu släppt',
    releases: 'Släpps {date}',
    days: 'Dagar',
    hours: 'Tim',
    minutes: 'Min',
    seconds: 'Sek',
    seeInStore: 'Se dropet i butiken',
  },
  app: {
    listingGone: 'Annonsen finns inte längre',
    openListingFailed: 'Kunde inte öppna annonsen',
    confirmDeleteCollection: 'Ta bort denna kollektion?',
    deleteCollectionFailed: 'Kunde inte ta bort kollektionen',
    confirmDeleteProduct: 'Ta bort denna produkt?',
    deleteProductFailed: 'Kunde inte ta bort produkten',
    loadingApp: 'Laddar Qvestium...',
    articleCount: { one: '{count} artikel', other: '{count} artiklar' },
    tryClearFilter: 'Prova att rensa något filter',
    loginToSeeMessages: 'Logga in för att se dina meddelanden.',
    loginToSeeProfile: 'Logga in för att se din profil',
    nav: {
      search: 'Sök',
      myProfile: 'Min profil',
      profileFallback: 'Profil',
      logOut: 'Logga ut',
      messages: 'Meddelanden',
      messagesUnread: { one: 'Meddelanden, {count} oläst', other: 'Meddelanden, {count} olästa' },
    },
    drops: {
      title: 'Kommande drops',
      subtitle: 'Schemalagda plaggsläpp från Qvestiums säljare',
      loading: 'Laddar drops...',
      emptyTitle: 'Inga drops just nu',
      emptyHint: 'Håll utkik — nya plaggsläpp dyker upp här när säljare schemalägger dem.',
      badgeLive: 'Live',
      badgeSoon: 'Snart',
      released: 'Släpptes {date}',
      releases: 'Släpps {date}',
    },
    plagg: {
      title: 'Plagg',
      emptyInArea: 'Inga plagg inom området',
      emptyNone: 'Inga plagg listade än',
      emptyNoMatch: 'Inga plagg matchar filtren',
      tryLargerArea: 'Prova ett större område',
      beFirst: 'Bli först — ladda upp ditt plagg i Min garderob!',
    },
    accessoarer: {
      title: 'Accessoarer',
      subtitle: 'Accessoarer, skor och väskor som andra användare listat',
      emptyNone: 'Inga accessoarer listade än',
      emptyNoMatch: 'Inga accessoarer matchar filtren',
      beFirst: 'Bli först — ladda upp din accessoar i Min garderob!',
    },
    footer: {
      tagline: 'Qvestium gör din garderob smart. Ladda upp dina plagg och byt, hyr ut eller sälj dem enkelt till andra.',
      shop: 'Butik',
      contact: 'Kontakt',
      contactUs: 'Kontakta oss',
      reportIllegal: 'Anmäl olagligt innehåll',
      sustainability: 'Hållbarhet',
      sustainabilityText: 'Tillsammans gör vi mode ännu mer hållbart när vi tillsammans dynamiskt delar garderob med varandra.',
    },
    checkout: {
      successTitle: 'Betalning genomförd!',
      successText: 'Tack för din beställning. Du får en bekräftelse via e-post.',
      orderRef: 'Order: {id}...',
      continueShopping: 'Fortsätt handla',
      cancelTitle: 'Betalning avbruten',
      cancelText: 'Inga pengar har dragits. Dina varor finns kvar i korgen.',
      backToStore: 'Tillbaka till butiken',
    },
  },
  // ── Slut komponenter ──
  // Visningsnamn för datavärden som sparas på svenska i databasen — använd
  // vl('category', värde). Värdet i sig ändras aldrig.
  values: {
    category: {
      Alla: 'Alla',
      Plagg: 'Plagg',
      Accessoarer: 'Accessoarer',
      Skor: 'Skor',
      Väskor: 'Väskor',
      Övrigt: 'Övrigt',
      Kollektion: 'Kollektion',
    },
    collectionCategory: {
      Alla: 'Alla',
      Kvinna: 'Kvinna',
      Man: 'Man',
      Barn: 'Barn',
      Unisex: 'Unisex',
    },
    style: {
      Alla: 'Alla',
      Klassisk: 'Klassisk',
      Modern: 'Modern',
      Streetwear: 'Streetwear',
      Formell: 'Formell',
      Casual: 'Casual',
      Bohemisk: 'Bohemisk',
    },
    priceUnit: {
      'kr': 'kr',
      'kr/mån': 'kr/mån',
      'kr/plagg': 'kr/plagg',
      'kr/set': 'kr/set',
      'kr/klänning': 'kr/klänning',
      'kr/kostym': 'kr/kostym',
    },
    stylePref: {
      Minimalistisk: 'Minimalistisk',
      Maximalistisk: 'Maximalistisk',
      Vintage: 'Vintage',
      Bohemisk: 'Bohemisk',
      Preppy: 'Preppy',
      Athleisure: 'Athleisure',
      'Business casual': 'Business casual',
      'Avant-garde': 'Avant-garde',
    },
  },
  marketing: {
    intro: 'Annonsmaterial, kampanjer på Meta och TikTok och vad annonserna leder till: besök, registreringar och konton som lägger upp plagg inom en vecka.',
    loadFailed: 'Kunde inte hämta kampanjerna',
    newCampaign: 'Ny kampanj',
    addLaunchTest: 'Lägg in testplanen',
    create: 'Skapa',
    working: 'Arbetar…',
    start: 'Starta',
    pause: 'Pausa',
    empty: {
      title: 'Ingen kampanj än',
      body: 'Börja med lanseringstestet från kampanjförslaget: tre koncept med två öppningar var, 6 000 kr över två veckor, med checklista och annonstexter ifyllda.',
      cta: 'Lägg in testplanen',
    },
    sections: { results: 'Resultat', creatives: 'Annonsmaterial', plan: 'Plan och budget', platforms: 'Meta och TikTok' },
    status: { draft: 'Utkast', live: 'Igång', paused: 'Pausad', done: 'Avslutad', idea: 'Idé', production: 'I produktion', ready: 'Klar', stopped: 'Stoppad' },
    kpi: {
      spend: 'Spenderat',
      ofBudget: 'av {budget} · {left} kvar',
      visits: 'Besök från annonser',
      perVisit: '{cost} per besök',
      registrations: 'Registreringar',
      unverified: '+ {count} som inte bekräftat e-posten',
      costPerRegistration: 'Kostnad per registrering',
      activated: 'Aktiverade inom 7 dagar',
      activationRate: '{rate} av registrerade · {pending} väntar',
      costPerActivated: 'Kostnad per aktiverad',
      requests: 'Förfrågningar',
      transactions: '{count} genomförda affärer',
    },
    results: {
      sync: 'Hämta resultat',
      lastSync: 'Senast hämtat: {when}',
      neverSynced: 'Inga resultat hämtade från Meta eller TikTok än.',
      notConnected: 'inte kopplat',
      rowsSynced: '{count} rader',
      perConcept: 'Per koncept',
      perOpening: 'Per öppning',
      variant: 'Öppning',
      concept: 'Koncept',
      spend: 'Spenderat',
      impressions: 'Visningar',
      hookRate: 'Stannar',
      hookRateHint: 'Andel visningar som tittat minst 2 sekunder. Jämför öppningar — inte affärsmålet.',
      clicks: 'Klick',
      visits: 'Besök',
      visitsHint: 'Egna besök från annonslänken / landningssidvisningar enligt Meta',
      perVisit: 'kr/besök',
      registrations: 'Reg.',
      perRegistration: 'kr/reg.',
      activated: 'Aktiverade',
      activatedHint: 'Lagt upp sitt första plagg inom 7 dagar från registreringen',
      requests: 'Förfrågn.',
      transactions: 'Affärer',
      unknownVariant: 'Okänd variant',
      unknownVariantHint: 'Kampanjens trafik där utm_content saknas eller inte matchar',
      total: 'Totalt',
      platformLine: '{spend} · {visits} besök · {regs} reg. · {cpr}/reg.',
      howToRead: 'Så läser du testet.',
      decisionRule: 'Välj vinnare efter handling, inte efter tittartid. Kostnad per registrering är det första gemensamma måttet; andelen som lägger upp ett plagg inom 7 dagar visar kvaliteten. Jämför först när varianterna fått rimlig exponering — noll registreringar efter ett fåtal klick är ingen förlorare. Med få registreringar är testet vägledande, inte statistiskt säkert.',
    },
    chart: { spend: 'Spenderat per dag', registrations: 'Registreringar', label: 'Spenderat och registreringar per dag' },
    creatives: {
      intro: 'Varje öppning har en egen annonslänk per plattform. Länken bär kampanjkoden {code}, så besökare kan registrera sig direkt, och utm_content avgör vilken öppning registreringen räknas till. Använd samma länk i Ads Manager om du bygger annonsen där.',
      add: 'Ny öppning',
      none: 'Inget annonsmaterial än.',
      concept: 'Koncept',
      variantKey: 'Variantnyckel (utm_content)',
      hook: 'Öppning',
      adText: 'Annonstext',
      cta: 'CTA',
      landingPath: 'Landningssida',
      desiredAction: 'Önskad handling:',
      showScript: 'Visa manus',
      hideScript: 'Dölj manus',
      noMedia: 'Ingen film än',
      uploadMedia: 'Ladda upp film',
      replaceMedia: 'Byt film',
      uploading: 'Laddar upp…',
      mediaSpec: 'Stående MP4, 1080 × 1920, max 200 MB',
      copyLink: 'Kopiera länk',
      copied: 'Kopierad',
      adId: 'annons {id}',
      notPublished: 'inte publicerad',
      confirmStartAd: 'Starta {variant} på {platform}? Annonsen börjar visas och kosta pengar om kampanjen är igång.',
      confirmDelete: 'Ta bort {variant}? Publicerade annonser ligger kvar hos plattformen.',
      delete: 'Ta bort',
    },
    plan: {
      name: 'Namn',
      status: 'Status',
      budget: 'Total budget (kr)',
      dailyBudget: 'Dagsbudget (kr)',
      startDate: 'Start',
      endDate: 'Slut',
      audience: 'Målgrupp',
      notes: 'Anteckningar och beslutsregel',
      inviteCode: 'Kampanjkod i annonslänkarna:',
      checklist: 'Checklista',
      noWhen: 'Övrigt',
      when: 'När',
      newItem: 'Ny punkt',
      removeItem: 'Ta bort',
      delete: 'Ta bort kampanjen',
      confirmDelete: 'Ta bort {name} med allt annonsmaterial? Resultat hos Meta och TikTok påverkas inte.',
    },
    platforms: {
      intro: 'Publicera skapar kampanj, annonsgrupp och en annons per klar öppning hos plattformen — allt pausat, så inget kostar pengar. Alla öppningar hamnar i samma annonsgrupp med samma målgrupp (Sverige, 18+) och dagsbudget, som testplanen föreskriver. Starta när filmerna är granskade.',
      connected: 'Kopplat',
      notConnected: 'Inte kopplat',
      problem: 'Problem',
      account: 'Annonskonto: {account} ({currency})',
      currencyWarning: 'Annonskontot använder {currency}, inte SEK — budgetar och kostnader räknas i den valutan.',
      setup: 'Lägg in i Secret Manager och deploya API:t:',
      metaSetup: 'Skapa en systemanvändare i Meta Business Manager med behörighet till annonskontot och sidan, och en token med ads_management och ads_read.',
      tiktokSetup: 'Skapa en app i TikTok for Business, godkänn annonskontot och hämta en långlivad token. Identiteten är kontot annonserna visas från.',
      notPublished: 'Inte publicerad än.',
      publishedIds: 'Publicerad · kampanj {campaign}',
      readyCount: '{count} klara öppningar att publicera',
      publish: 'Publicera pausat',
      publishMore: 'Publicera nya öppningar',
      published: '{count} annonser skapade pausade på {platform}.',
      skippedImages: 'Hoppade över {variants} (TikTok kräver film).',
      confirmStart: 'Starta kampanjen på {platform}? Den börjar visas direkt med {daily} per dag (total budget {budget}).',
      started: 'Kampanjen är igång på {platform}.',
      paused: 'Kampanjen är pausad på {platform}.',
      openManager: 'Öppna {platform} Ads Manager',
      manualHint: 'Bygger du annonser direkt i Ads Manager: döp kampanjen så att namnet innehåller {utm} och varje annons så att namnet innehåller variantnyckeln (t.ex. friends_a), och använd annonslänken från Annonsmaterial. Då hamnar resultaten rätt här när du hämtar dem.',
    },
  },
};

export default sv;
